function mod(n, t) {
    return n - t * Math.floor(n / t)
}

function leap_gregorian(n) {
    return n % 4 == 0 && !(n % 100 == 0 && n % 400 != 0)
}

function gregorian_to_jd(n, t, i) {
    return GREGORIAN_EPOCH - 1 + 365 * (n - 1) + Math.floor((n - 1) / 4) + -Math.floor((n - 1) / 100) + Math.floor((n - 1) / 400) + Math.floor((367 * t - 362) / 12 + (t <= 2 ? 0 : leap_gregorian(n) ? -1 : -2) + i)
}

function jd_to_gregorian(n) {
    var i, r, s, u, f, e, h, c, o, t, l, a;
    return i = Math.floor(n - .5) + .5, r = i - GREGORIAN_EPOCH, s = Math.floor(r / 146097), u = mod(r, 146097), f = Math.floor(u / 36524), e = mod(u, 36524), h = Math.floor(e / 1461), c = mod(e, 1461), o = Math.floor(c / 365), t = s * 400 + f * 100 + h * 4 + o, f == 4 || o == 4 || t++, l = i - gregorian_to_jd(t, 1, 1), a = i < gregorian_to_jd(t, 3, 1) ? 0 : leap_gregorian(t) ? 1 : 2, month = Math.floor(((l + a) * 12 + 373) / 367), day = i - gregorian_to_jd(t, month, 1) + 1, [t, month, day]
}

function leap_islamic(n) {
    return (n * 11 + 14) % 30 < 11
}

function islamic_to_jd(n, t, i) {
    return i + Math.ceil(29.5 * (t - 1)) + (n - 1) * 354 + Math.floor((3 + 11 * n) / 30) + ISLAMIC_EPOCH - 1
}

function jd_to_islamic(n) {
    var t, i, r;
    return n = Math.floor(n) + .5, t = Math.floor((30 * (n - ISLAMIC_EPOCH) + 10646) / 10631), i = Math.min(12, Math.ceil((n - (29 + islamic_to_jd(t, 1, 1))) / 29.5) + 1), r = n - islamic_to_jd(t, i, 1) + 1, [t, i, r]
}

function leap_persian(n) {
    return ((n - (n > 0 ? 474 : 473)) % 2820 + 474 + 38) * 682 % 2816 < 682
}

function persian_to_jd(n, t, i) {
    var r, u;
    return r = n - (n >= 0 ? 474 : 473), u = 474 + mod(r, 2820), i + (t <= 7 ? (t - 1) * 31 : (t - 1) * 30 + 6) + Math.floor((u * 682 - 110) / 2816) + (u - 1) * 365 + Math.floor(r / 2820) * 1029983 + (PERSIAN_EPOCH - 1)
}

function jd_to_persian(n) {
    var t, u, s, f, h, i, e, o, c, r;
    return n = Math.floor(n) + .5, f = n - persian_to_jd(475, 1, 1), h = Math.floor(f / 1029983), i = mod(f, 1029983), i == 1029982 ? e = 2820 : (o = Math.floor(i / 366), c = mod(i, 366), e = Math.floor((2134 * o + 2816 * c + 2815) / 1028522) + o + 1), t = e + 2820 * h + 474, t <= 0 && t--, r = n - persian_to_jd(t, 1, 1) + 1, u = r <= 186 ? Math.ceil(r / 31) : Math.ceil((r - 6) / 30), s = n - persian_to_jd(t, u, 1) + 1, [t, u, s]
}

function JalaliDate(n, t, i) {
    function e(n) {
        var i = 0,
            t;
        return n[1] < 0 && (i = leap_persian(n[0] - 1) ? 30 : 29, n[1]++), t = jd_to_gregorian(persian_to_jd(n[0], n[1] + 1, n[2]) - i), t[1]--, t
    }

    function o(n) {
        var t = jd_to_persian(gregorian_to_jd(n[0], n[1] + 1, n[2]));
        return t[1]--, t
    }

    function s(n) {
        return n && n.getGregorianDate && (n = n.getGregorianDate()), r = new Date(n), r.setHours(r.getHours() > 12 ? r.getHours() + 2 : 0), (!r || r == "Invalid Date" || isNaN(r || !r.getDate())) && (r = new Date), u = o([r.getFullYear(), r.getMonth(), r.getDate()]), this
    }
    var r, u, f;
    isNaN(parseInt(n)) || isNaN(parseInt(t)) || isNaN(parseInt(i)) ? s(n) : (f = e([parseInt(n, 10), parseInt(t, 10), parseInt(i, 10)]), s(new Date(f[0], f[1], f[2])));
    this.getGregorianDate = function() {
        return r
    };
    this.setFullDate = s;
    this.setMonth = function(n) {
        u[1] = n;
        var t = e(u);
        r = new Date(t[0], t[1], t[2]);
        u = o([t[0], t[1], t[2]])
    };
    this.setDate = function(n) {
        u[2] = n;
        var t = e(u);
        r = new Date(t[0], t[1], t[2]);
        u = o([t[0], t[1], t[2]])
    };
    this.getFullYear = function() {
        return u[0]
    };
    this.getMonth = function() {
        return u[1]
    };
    this.getDate = function() {
        return u[2]
    };
    this.toString = function() {
        return u.join(",").toString()
    };
    this.getDay = function() {
        return r.getDay()
    };
    this.getHours = function() {
        return r.getHours()
    };
    this.getMinutes = function() {
        return r.getMinutes()
    };
    this.getSeconds = function() {
        return r.getSeconds()
    };
    this.getTime = function() {
        return r.getTime()
    };
    this.getTimeZoneOffset = function() {
        return r.getTimeZoneOffset()
    };
    this.getYear = function() {
        return u[0] % 100
    };
    this.setHours = function(n) {
        r.setHours(n)
    };
    this.setMinutes = function(n) {
        r.setMinutes(n)
    };
    this.setSeconds = function(n) {
        r.setSeconds(n)
    };
    this.setMilliseconds = function(n) {
        r.setMilliseconds(n)
    }
}

function leapGregorian(n) {
    return n % 4 == 0 && !(n % 100 == 0 && n % 400 != 0)
}

function leapHijri(n) {
    return (n * 11 + 14) % 30 < 11
}

function leapPersian(n) {
    return ((n - (n > 0 ? 474 : 473)) % 2820 + 474 + 38) * 682 % 2816 < 682
}

function jdToPersian(n) {
    var t, u, s, f, h, i, e, o, c, r;
    return n = Math.floor(n) + .5, f = n - 2121445.5, h = Math.floor(f / 1029983), i = mod(f, 1029983), i == 1029982 ? e = 2820 : (o = Math.floor(i / 366), c = mod(i, 366), e = Math.floor((2134 * o + 2816 * c + 2815) / 1028522) + o + 1), t = e + 2820 * h + 474, t <= 0 && t--, r = n - persianToJD(t, 1, 1) + 1, u = r <= 186 ? Math.ceil(r / 31) : Math.ceil((r - 6) / 30), s = n - persianToJD(t, u, 1) + 1, [t, u, s]
}

function persianToJD(n, t, i) {
    var r, u;
    return r = n - (n >= 0 ? 474 : 473), u = 474 + mod(r, 2820), i + (t <= 7 ? (t - 1) * 31 : (t - 1) * 30 + 6) + Math.floor((u * 682 - 110) / 2816) + (u - 1) * 365 + Math.floor(r / 2820) * 1029983 + (PERSIAN_EPOCH - 1)
}

function jdToGregorian(n) {
    var i, r, h, u, f, e, c, l, o, t, s, a, v, y;
    return i = Math.floor(n - .5) + .5, r = i - GREGORIAN_EPOCH, h = Math.floor(r / 146097), u = mod(r, 146097), f = Math.floor(u / 36524), e = mod(u, 36524), c = Math.floor(e / 1461), l = mod(e, 1461), o = Math.floor(l / 365), t = h * 400 + f * 100 + c * 4 + o, f == 4 || o == 4 || t++, v = i - gregorianToJD(t, 1, 1), y = i < gregorianToJD(t, 3, 1) ? 0 : leapGregorian(t) ? 1 : 2, s = Math.floor(((v + y) * 12 + 373) / 367), a = i - gregorianToJD(t, s, 1) + 1, [t, s, a]
}

function gregorianToJD(n, t, i) {
    return GREGORIAN_EPOCH - 1 + 365 * (n - 1) + Math.floor((n - 1) / 4) + -Math.floor((n - 1) / 100) + Math.floor((n - 1) / 400) + Math.floor((367 * t - 362) / 12 + (t <= 2 ? 0 : leapGregorian(n) ? -1 : -2) + i)
}

function hijriToJD(n, t, i) {
    return i + Math.ceil(29.5 * (t - 1)) + (n - 1) * 354 + Math.floor((3 + 11 * n) / 30) + ISLAMIC_EPOCH - 1
}

function jdToHijri(n) {
    var t, i, r;
    return n = Math.floor(n) + .5, t = Math.floor((30 * (n - ISLAMIC_EPOCH) + 10646) / 10631), i = Math.min(12, Math.ceil((n - (29 + hijriToJD(t, 1, 1))) / 29.5) + 1), r = n - hijriToJD(t, i, 1) + 1, [t, i, r]
}! function(n) {
    "function" == typeof define && define.amd ? define(["jquery"], function(t) {
        n(window, document, t)
    }) : "object" == typeof exports ? module.exports = n(window, document, require("jquery")) : n(window, document, window.jQuery)
}(function(n, t, i, r) {
    var o;
    n.Typeahead = {
        version: "2.3.0"
    };
    var s = {
            input: null,
            minLength: 2,
            maxItem: 8,
            dynamic: !1,
            delay: 300,
            order: null,
            offset: !1,
            hint: !1,
            accent: !1,
            highlight: !0,
            group: !1,
            groupOrder: null,
            maxItemPerGroup: null,
            dropdownFilter: !1,
            dynamicFilter: null,
            backdrop: !1,
            backdropOnFocus: !1,
            cache: !1,
            ttl: 36e5,
            compression: !1,
            suggestion: !1,
            searchOnFocus: !1,
            resultContainer: null,
            generateOnLoad: null,
            mustSelectItem: !1,
            href: null,
            display: ["display"],
            template: null,
            correlativeTemplate: !1,
            emptyTemplate: !1,
            filter: !0,
            matcher: null,
            source: null,
            callback: {
                onInit: null,
                onReady: null,
                onShowLayout: null,
                onHideLayout: null,
                onSearch: null,
                onResult: null,
                onLayoutBuiltBefore: null,
                onLayoutBuiltAfter: null,
                onNavigateBefore: null,
                onNavigateAfter: null,
                onMouseEnter: null,
                onMouseLeave: null,
                onClickBefore: null,
                onClickAfter: null,
                onSendRequest: null,
                onReceiveRequest: null,
                onSubmit: null
            },
            selector: {
                container: "typeahead-container",
                result: "typeahead-result",
                list: "typeahead-list",
                group: "typeahead-group",
                item: "typeahead-item",
                empty: "typeahead-empty",
                display: "typeahead-display",
                query: "typeahead-query",
                filter: "typeahead-filter",
                filterButton: "typeahead-filter-button",
                filterValue: "typeahead-filter-value",
                dropdown: "typeahead-dropdown",
                dropdownCaret: "typeahead-caret",
                button: "typeahead-button",
                backdrop: "typeahead-backdrop",
                hint: "typeahead-hint"
            },
            debug: !1
        },
        u = ".typeahead",
        f = {
            from: "ãàáäâẽèéëêìíïîõòóöôùúüûñç",
            to: "aaaaaeeeeeiiiiooooouuuunc"
        },
        h = ~navigator.appVersion.indexOf("MSIE 9."),
        e = function(n, t) {
            this.rawQuery = "";
            this.query = "";
            this.tmpSource = {};
            this.source = {};
            this.isGenerated = null;
            this.generatedGroupCount = 0;
            this.groupCount = 0;
            this.groupBy = "group";
            this.result = {};
            this.resultCount = 0;
            this.options = t;
            this.node = n;
            this.container = null;
            this.resultContainer = null;
            this.item = null;
            this.xhr = {};
            this.hintIndex = null;
            this.filters = {
                dropdown: {},
                dynamic: {}
            };
            this.requests = {};
            this.backdrop = {};
            this.hint = {};
            this.__construct()
        };
    e.prototype = {
        extendOptions: function() {
            this.options.dynamic && (this.options.cache = !1, this.options.compression = !1);
            this.options.cache && (this.options.cache = function(t) {
                var i;
                if (t === !0) t = "localStorage";
                else if ("string" == typeof t && !~["localStorage", "sessionStorage"].indexOf(t)) return !1;
                i = "undefined" != typeof n[t];
                try {
                    n[t].setItem("typeahead", "typeahead");
                    n[t].removeItem("typeahead")
                } catch (r) {
                    i = !1
                }
                return i && t || !1
            }.call(this, this.options.cache));
            this.options.compression && ("object" == typeof LZString && this.options.cache || (this.options.compression = !1));
            "undefined" == typeof this.options.maxItem || /^\d+$/.test(this.options.maxItem) && 0 !== this.options.maxItem || (this.options.maxItem = 1 / 0);
            this.options.maxItemPerGroup && !/^\d+$/.test(this.options.maxItemPerGroup) && (this.options.maxItemPerGroup = null);
            !this.options.display || this.options.display instanceof Array || (this.options.display = [this.options.display]);
            !this.options.group || this.options.group instanceof Array || (this.options.group = [this.options.group]);
            this.options.highlight && !~["any", !0].indexOf(this.options.highlight) && (this.options.highlight = !1);
            !this.options.dynamicFilter || this.options.dynamicFilter instanceof Array || (this.options.dynamicFilter = [this.options.dynamicFilter]);
            this.options.accent && ("object" == typeof this.options.accent ? this.options.accent.from && this.options.accent.to && this.options.accent.from.length === this.options.accent.to.length : this.options.accent = f);
            this.options.resultContainer && ("string" == typeof this.options.resultContainer && (this.options.resultContainer = i(this.options.resultContainer)), this.options.resultContainer instanceof jQuery && this.options.resultContainer[0] && (this.resultContainer = this.options.resultContainer));
            this.options.group && "string" == typeof this.options.group[0] && this.options.maxItemPerGroup && (this.groupBy = this.options.group[0]);
            this.options.callback && this.options.callback.onClick && (this.options.callback.onClickBefore = this.options.callback.onClick, delete this.options.callback.onClick);
            this.options.callback && this.options.callback.onNavigate && (this.options.callback.onNavigateBefore = this.options.callback.onNavigate, delete this.options.callback.onNavigate);
            this.options = i.extend(!0, {}, s, this.options)
        },
        unifySourceFormat: function() {
            var n, t;
            if (this.options.source instanceof Array) return this.options.source = {
                group: {
                    data: this.options.source
                }
            }, this.groupCount += 1, !0;
            ("undefined" != typeof this.options.source.data || "undefined" != typeof this.options.source.url) && (this.options.source = {
                group: this.options.source
            });
            for (t in this.options.source)
                if (this.options.source.hasOwnProperty(t)) {
                    if (n = this.options.source[t], ("string" == typeof n || n instanceof Array) && (n = {
                            url: n
                        }), !n.data && !n.url) return !1;
                    !n.display || n.display instanceof Array || (n.display = [n.display]);
                    n.ignore && (n.ignore instanceof RegExp || delete n.ignore);
                    this.options.source[t] = n;
                    this.groupCount += 1
                } return !0
        },
        init: function() {
            this.helper.executeCallback.call(this, this.options.callback.onInit, [this.node]);
            this.container = this.node.closest("." + this.options.selector.container)
        },
        delegateEvents: function() {
            var n = this,
                r = ["focus" + u, "input" + u, "propertychange" + u, "keydown" + u, "keyup" + u, "dynamic" + u, "generateOnLoad" + u],
                t;
            this.container.off(u).on("click" + u + " touchstart" + u, function(t) {
                t.stopPropagation();
                n.options.dropdownFilter && n.container.hasClass("filter") && !i(t.target).closest("." + n.options.selector.dropdown.replace(" ", "."))[0] && n.container.removeClass("filter")
            });
            this.node.closest("form").on("submit", function(t) {
                return n.options.mustSelectItem && n.helper.isEmpty(n.item) ? void t.preventDefault() : (n.hideLayout(), n.rawQuery = "", n.query = "", n.helper.executeCallback.call(n, n.options.callback.onSubmit, [n.node, this, n.item, t]) ? !1 : void 0)
            });
            t = !1;
            this.node.off(u).on(r.join(" "), function(i) {
                switch (i.type) {
                    case "focus":
                        n.options.backdropOnFocus && (n.buildBackdropLayout(), n.showLayout());
                    case "generateOnLoad":
                        n.isGenerated && n.options.searchOnFocus && n.query.length >= n.options.minLength && n.showLayout();
                        null !== n.isGenerated || n.options.dynamic || n.generateSource();
                        break;
                    case "keydown":
                        i.keyCode && ~[9, 13, 27, 38, 39, 40].indexOf(i.keyCode) && (t = !0, n.navigate(i));
                        break;
                    case "keyup":
                        h && n.node[0].value.replace(/^\s+/, "").toString().length < n.query.length && n.node.trigger("input" + u);
                        break;
                    case "propertychange":
                        if (t) {
                            t = !1;
                            break
                        }
                    case "input":
                        if (n.rawQuery = n.node[0].value.toString(), n.query = n.rawQuery.replace(/^\s+/, ""), n.options.hint && n.hint.container && "" !== n.hint.container.val() && 0 !== n.hint.container.val().indexOf(n.rawQuery) && n.hint.container.val(""), n.options.dynamic) return n.isGenerated = null, void n.helper.typeWatch(function() {
                            n.query.length >= n.options.minLength ? n.generateSource() : n.hideLayout()
                        }, n.options.delay);
                    case "dynamic":
                        if (!n.isGenerated) break;
                        if (n.query.length < n.options.minLength) {
                            n.resetLayout();
                            n.hideLayout();
                            break
                        }
                        n.searchResult();
                        n.buildLayout();
                        n.result.length > 0 || n.options.emptyTemplate ? n.showLayout() : n.hideLayout()
                }
            });
            this.options.generateOnLoad && this.node.trigger("generateOnLoad" + u)
        },
        generateSource: function() {
            var u, t, r, i, f;
            if (!this.isGenerated || this.options.dynamic) {
                if (this.generatedGroupCount = 0, this.isGenerated = !1, !this.helper.isEmpty(this.xhr)) {
                    for (u in this.xhr) this.xhr.hasOwnProperty(u) && this.xhr[u].abort();
                    this.xhr = {}
                }
                for (t in this.options.source)
                    if (this.options.source.hasOwnProperty(t)) {
                        if (r = this.options.source[t], this.options.cache && (i = n[this.options.cache].getItem(this.node.selector + ":" + t))) {
                            this.options.compression && (i = LZString.decompressFromUTF16(i));
                            f = !1;
                            try {
                                i = JSON.parse(i + "");
                                i.data && i.ttl > (new Date).getTime() ? (this.populateSource(i.data, t), f = !0) : n[this.options.cache].removeItem(this.node.selector + ":" + t)
                            } catch (e) {}
                            if (f) continue
                        }!r.data || r.url ? r.url && (this.requests[t] || (this.requests[t] = this.generateRequestObject(t))) : this.populateSource("function" == typeof r.data && r.data() || r.data, t)
                    } this.handleRequests()
            }
        },
        generateRequestObject: function(n) {
            var f = this,
                t = this.options.source[n],
                r, e, u;
            t.url instanceof Array || (t.url = [t.url]);
            r = {
                request: {
                    url: null,
                    dataType: "json",
                    beforeSend: function(i) {
                        f.xhr[n] = i;
                        var r = f.requests[n].extra.beforeSend || t.url[0].beforeSend;
                        "function" == typeof r && r.apply(null, arguments)
                    }
                },
                extra: {
                    path: null,
                    group: n,
                    callback: {
                        done: null,
                        fail: null,
                        complete: null,
                        always: null
                    }
                },
                validForGroup: [n]
            };
            Object.defineProperty(r.request, "beforeSend", {
                writable: !1
            });
            t.url[0] instanceof Object ? (t.url[0].callback && (r.extra.callback = t.url[0].callback, delete t.url[0].callback), r.request = i.extend(!0, r.request, t.url[0])) : "string" == typeof t.url[0] && (r.request.url = t.url[0]);
            t.url[1] && "string" == typeof t.url[1] && (r.extra.path = t.url[1]);
            "jsonp" === r.request.dataType.toLowerCase() && (r.request.jsonpCallback = "callback_" + n);
            for (u in this.requests)
                if (this.requests.hasOwnProperty(u) && (e = JSON.stringify(this.requests[u].request), e === JSON.stringify(r.request))) {
                    this.requests[u].validForGroup.push(n);
                    r.isDuplicated = !0;
                    delete r.validForGroup;
                    break
                } return r
        },
        handleRequests: function() {
            var n = this,
                r = Object.keys(this.requests).length,
                t;
            this.helper.executeCallback.call(this, this.options.callback.onSendRequest, [this.node, this.query]);
            for (t in this.requests) this.requests.hasOwnProperty(t) && (this.requests[t].isDuplicated || ! function(t, u) {
                var s, f, e, o;
                if ("function" == typeof n.options.source[t].url[0]) {
                    if (s = n.options.source[t].url[0].call(n, n.query), u.request = i.extend(!0, u.request, s), "object" != typeof u.request || !u.request.url) return;
                    s.beforeSend && (n.requests[t].extra.beforeSend = s.beforeSend)
                }
                if (e = !1, ~u.request.url.indexOf("{{query}}") && (e || (u = i.extend(!0, {}, u), e = !0), u.request.url = u.request.url.replace("{{query}}", n.query.sanitize())), u.request.data)
                    for (o in u.request.data)
                        if (u.request.data.hasOwnProperty(o) && ~String(u.request.data[o]).indexOf("{{query}}")) {
                            e || (u = i.extend(!0, {}, u), e = !0);
                            u.request.data[o] = u.request.data[o].replace("{{query}}", n.query.sanitize());
                            break
                        } i.ajax(u.request).done(function(t, i, e) {
                    for (var o, s = 0; s < u.validForGroup.length; s++) f = n.requests[u.validForGroup[s]], f.extra.callback.done instanceof Function && (o = f.extra.callback.done(t, i, e), t = o instanceof Array && o || t), n.populateSource(t, f.extra.group, f.extra.path), r -= 1, 0 === r && n.helper.executeCallback.call(n, n.options.callback.onReceiveRequest, [n.node, n.query])
                }).fail(function(t, i, r) {
                    for (var e = 0; e < u.validForGroup.length; e++) f = n.requests[u.validForGroup[e]], f.extra.callback.fail instanceof Function && f.extra.callback.fail(t, i, r)
                }).then(function(t, i) {
                    for (var r = 0; r < u.validForGroup.length; r++) f = n.requests[u.validForGroup[r]], f.extra.callback.then instanceof Function && f.extra.callback.then(t, i)
                }).always(function(t, i, r) {
                    for (var e = 0; e < u.validForGroup.length; e++) f = n.requests[u.validForGroup[e]], f.extra.callback.always instanceof Function && f.extra.callback.always(t, i, r)
                })
            }(t, this.requests[t]))
        },
        populateSource: function(t, i, r) {
            var a = this,
                f = this.options.source[i],
                e = f.url && f.data,
                h, l, c, o, u, s;
            for (t = "string" == typeof r ? this.helper.namespace(r, t) : t, t instanceof Array || (t = []), e && ("function" == typeof e && (e = e()), e instanceof Array && (t = t.concat(e))), l = f.display ? "compiled" === f.display[0] ? f.display[1] : f.display[0] : "compiled" === this.options.display[0] ? this.options.display[1] : this.options.display[0], u = 0; u < t.length; u++) "string" == typeof t[u] && (h = {}, h[l] = t[u], t[u] = h), t[u].group = i;
            if (this.options.correlativeTemplate && (c = f.template || this.options.template, o = "", c)) {
                if (this.options.correlativeTemplate instanceof Array)
                    for (u = 0; u < this.options.correlativeTemplate.length; u++) o += "{{" + this.options.correlativeTemplate[u] + "}} ";
                else o = c.replace(/<.+?>/g, "");
                for (u = 0; u < t.length; u++) t[u].compiled = o.replace(/\{\{([\w\-\.]+)(?:\|(\w+))?}}/g, function(n, i) {
                    return a.helper.namespace(i, t[u], "get", "")
                }).trim();
                f.display ? ~f.display.indexOf("compiled") || f.display.unshift("compiled") : ~this.options.display.indexOf("compiled") || this.options.display.unshift("compiled")
            }(this.tmpSource[i] = t, this.options.cache && !n[this.options.cache].getItem(this.node.selector + ":" + i)) && (s = JSON.stringify({
                data: t,
                ttl: (new Date).getTime() + this.options.ttl
            }), this.options.compression && (s = LZString.compressToUTF16(s)), n[this.options.cache].setItem(this.node.selector + ":" + i, s));
            this.incrementGeneratedGroup()
        },
        incrementGeneratedGroup: function() {
            if (this.generatedGroupCount += 1, this.groupCount === this.generatedGroupCount) {
                this.isGenerated = !0;
                this.xhr = {};
                for (var t = Object.keys(this.options.source), n = 0; n < t.length; n++) this.source[t[n]] = this.tmpSource[t[n]];
                this.tmpSource = {};
                this.node.trigger("dynamic" + u)
            }
        },
        navigate: function(n) {
            if (this.helper.executeCallback.call(this, this.options.callback.onNavigateBefore, [this.node, this.query, n]), ~[9, 27].indexOf(n.keyCode)) return this.query.length || 27 !== n.keyCode || this.node.blur(), void this.hideLayout();
            if (this.isGenerated && this.result.length) {
                var i = this.resultContainer.find("> ul > li:not([data-search-group])"),
                    r = i.filter(".active"),
                    u = r[0] && i.index(r) || null,
                    t = null;
                if (13 === n.keyCode) return r.length > 0 ? (n.preventDefault(), n.stopPropagation(), void r.find("a:first").trigger("click")) : this.options.mustSelectItem && this.helper.isEmpty(this.item) ? void 0 : void this.hideLayout();
                if (39 === n.keyCode) return void(u ? i.eq(u).find("a:first")[0].click() : this.options.hint && "" !== this.hint.container.val() && this.helper.getCaret(this.node[0]) >= this.query.length && i.find('a[data-index="' + this.hintIndex + '"]')[0].click());
                i.length > 0 && r.removeClass("active");
                38 === n.keyCode ? (n.preventDefault(), r.length > 0 ? u - 1 >= 0 && (t = u - 1, i.eq(t).addClass("active")) : (t = i.length - 1, i.last().addClass("active"))) : 40 === n.keyCode && (n.preventDefault(), r.length > 0 ? u + 1 < i.length && (t = u + 1, i.eq(t).addClass("active")) : (t = 0, i.first().addClass("active")));
                n.preventInputChange && ~[38, 40].indexOf(n.keyCode) && this.buildHintLayout(null !== t && t < this.result.length ? [this.result[t]] : null);
                this.options.hint && this.hint.container && this.hint.container.css("color", n.preventInputChange ? this.hint.css.color : null === t && this.hint.css.color || this.hint.container.css("background-color") || "fff");
                this.node.val(null === t || n.preventInputChange ? this.rawQuery : this.result[t][this.result[t].matchedKey]);
                this.helper.executeCallback.call(this, this.options.callback.onNavigateAfter, [this.node, this.query, n])
            }
        },
        searchResult: function(n) {
            var y, h, it, f, t, rt, g, i;
            n || (this.item = {});
            this.helper.executeCallback.call(this, this.options.callback.onSearch, [this.node, this.query]);
            this.result = {};
            this.resultCount = 0;
            this.resultItemCount = 0;
            var t, u, p, e, f, w, c, nt, l, tt, a, b, k = this,
                d = this.options.group && "boolean" != typeof this.options.group[0] ? this.options.group[0] : "group",
                o = null,
                v = this.query.toLowerCase(),
                s = this.options.maxItemPerGroup,
                ut = this.filters.dynamic && !this.helper.isEmpty(this.filters.dynamic),
                ft = "function" == typeof this.options.matcher && this.options.matcher;
            this.options.accent && (v = this.helper.removeAccent.call(this, v));
            for (t in this.source)
                if (this.source.hasOwnProperty(t) && (!this.filters.dropdown || "group" !== this.filters.dropdown.key || this.filters.dropdown.value === t))
                    for (w = "undefined" != typeof this.options.source[t].filter ? this.options.source[t].filter : this.options.filter, nt = "function" == typeof this.options.source[t].matcher && this.options.source[t].matcher || ft, y = 0; y < this.source[t].length && (!(this.result.length >= this.options.maxItem) || this.options.callback.onResult); y++)
                        if (!ut || this.dynamicFilter.validate.apply(this, [this.source[t][y]])) {
                            if (u = this.source[t][y], o = "group" === d ? t : u[d], o && !this.result[o] && (this.result[o] = []), s && "group" === d && this.result[o].length >= s && !this.options.callback.onResult) break;
                            for (f = this.options.source[t].display || this.options.display, i = 0; i < f.length; i++) {
                                if ("function" == typeof w) {
                                    if (c = w.call(this, u, u[f[i]]), c === r) break;
                                    if (!c) continue;
                                    "object" == typeof c && (u = c)
                                }
                                if (~[r, !0].indexOf(w)) {
                                    if (e = u[f[i]], !e) continue;
                                    if (e = e.toString().toLowerCase(), this.options.accent && (e = this.helper.removeAccent.call(this, e)), p = e.indexOf(v), this.options.correlativeTemplate && "compiled" === f[i] && 0 > p && /\s/.test(v))
                                        for (tt = !0, a = v.split(" "), b = e, h = 0; h < a.length; h++)
                                            if ("" !== a[h]) {
                                                if (!~b.indexOf(a[h])) {
                                                    tt = !1;
                                                    break
                                                }
                                                b = b.replace(a[h], "")
                                            } if (0 > p && !tt) continue;
                                    if (this.options.offset && 0 !== p) continue;
                                    if (this.options.source[t].ignore && this.options.source[t].ignore.test(e)) continue;
                                    if (nt) {
                                        if (l = nt.call(this, u, u[f[i]]), l === r) break;
                                        if (!l) continue;
                                        "object" == typeof l && (u = l)
                                    }
                                }
                                if (!this.filters.dropdown || this.filters.dropdown.value == u[this.filters.dropdown.key]) {
                                    if (this.resultCount++, this.resultItemCount < this.options.maxItem) {
                                        if (s && this.result[o].length >= s) break;
                                        u.matchedKey = f[i];
                                        this.result[o].push(u);
                                        this.resultItemCount++
                                    }
                                    break
                                }
                            }
                            if (!this.options.callback.onResult) {
                                if (this.resultItemCount >= this.options.maxItem) break;
                                if (s && this.result[o].length >= s && "group" === d) break
                            }
                        } if (this.options.order) {
                f = [];
                for (t in this.result)
                    if (this.result.hasOwnProperty(t)) {
                        for (i = 0; i < this.result[t].length; i++) it = this.options.source[this.result[t][i].group].display || this.options.display, ~f.indexOf(it[0]) || f.push(it[0]);
                        this.result[t].sort(k.helper.sort(f, "asc" === k.options.order, function(n) {
                            return n.toString().toUpperCase()
                        }))
                    }
            }
            for (g = [], rt = "function" == typeof this.options.groupOrder ? this.options.groupOrder.apply(this, [this.node, this.query, this.result, this.resultCount]) : this.options.groupOrder instanceof Array ? this.options.groupOrder : "string" == typeof this.options.groupOrder && ~["asc", "desc"].indexOf(this.options.groupOrder) ? Object.keys(this.result).sort(k.helper.sort([], "asc" === k.options.groupOrder, function(n) {
                    return n.toString().toUpperCase()
                })) : Object.keys(this.result), i = 0; i < rt.length; i++) g = g.concat(this.result[rt[i]] || []);
            this.result = g;
            this.helper.executeCallback.call(this, this.options.callback.onResult, [this.node, this.query, this.result, this.resultCount])
        },
        buildLayout: function() {
            var t, n, r, u;
            this.resultContainer || (this.resultContainer = i("<div/>", {
                "class": this.options.selector.result
            }), this.container.append(this.resultContainer));
            t = this.query.toLowerCase();
            this.options.accent && (t = this.helper.removeAccent.call(this, t));
            n = this;
            r = i("<ul/>", {
                "class": this.options.selector.list + (n.helper.isEmpty(n.result) ? " empty" : ""),
                html: function() {
                    var r, u;
                    if (n.options.emptyTemplate && n.helper.isEmpty(n.result)) return r = "function" == typeof n.options.emptyTemplate ? n.options.emptyTemplate.call(n, n.query) : n.options.emptyTemplate.replace(/\{\{query}}/gi, n.query.sanitize()), r instanceof jQuery && "LI" === r[0].nodeName ? r : i("<li/>", {
                        "class": n.options.selector.empty,
                        html: i("<a/>", {
                            href: "javascript:;",
                            html: r
                        })
                    });
                    for (u in n.result) n.result.hasOwnProperty(u) && ! function(r, u, f) {
                        var l, h, c, s, e = u.group,
                            v = [],
                            a = n.options.source[u.group].display || n.options.display,
                            o = n.options.source[u.group].href || n.options.href;
                        n.options.group && (n.options.group[1] ? "function" == typeof n.options.group[1] ? e = n.options.group[1](u) : "string" == typeof n.options.group[1] && (e = n.options.group[1].replace(/(\{\{group}})/gi, u[n.options.group[0]] || e)) : "boolean" != typeof n.options.group[0] && u[n.options.group[0]] && (e = u[n.options.group[0]]), i(f).find('li[data-search-group="' + e + '"]')[0] || i(f).append(i("<li/>", {
                            "class": n.options.selector.group,
                            html: i("<a/>", {
                                href: "javascript:;",
                                html: e
                            }),
                            "data-search-group": e
                        })));
                        l = i("<li/>", {
                            "class": n.options.selector.item,
                            html: i("<a/>", {
                                href: function() {
                                    return o && ("string" == typeof o ? o = o.replace(/\{\{([\w\-\.]+)(?:\|(\w+))?}}/g, function(t, i, r) {
                                        var f = n.helper.namespace(i, u, "get", "");
                                        return r && "raw" === r ? f : n.helper.slugify.call(n, f)
                                    }) : "function" == typeof o && (o = o(u)), u.href = o), o || "javascript:;"
                                },
                                "data-group": e,
                                "data-index": r,
                                html: function() {
                                    if (s = u.group && n.options.source[u.group].template || n.options.template) "function" == typeof s && (s = s.call(n, n.query, u)), h = s.replace(/\{\{([\w\-\.]+)(?:\|(\w+))?}}/g, function(i, r, f) {
                                        var e = n.helper.namespace(r, u, "get", "");
                                        return f && "raw" === f || n.options.highlight === !0 && t && ~a.indexOf(r) && (e = n.helper.highlight.call(n, e, t.split(" "), n.options.accent)), e
                                    });
                                    else {
                                        for (var r = 0; r < a.length; r++) v.push(u[a[r]]);
                                        h = '<span class="' + n.options.selector.display + '">' + v.join(" ") + "<\/span>"
                                    }(n.options.highlight === !0 && t && !s || "any" === n.options.highlight) && (h = n.helper.highlight.call(n, h, t.split(" "), n.options.accent));
                                    i(this).append(h)
                                },
                                click: function(t) {
                                    return n.options.mustSelectItem && n.helper.isEmpty(u) ? void t.preventDefault() : (n.item = u, n.helper.executeCallback.call(n, n.options.callback.onClickBefore, [n.node, this, u, t]), void(t.originalEvent && t.originalEvent.defaultPrevented || t.isDefaultPrevented() || (n.query = n.rawQuery = u[u.matchedKey].toString(), n.node.val(n.query).focus(), n.searchResult(!0), n.buildLayout(), n.hideLayout(), n.helper.executeCallback.call(n, n.options.callback.onClickAfter, [n.node, this, u, t]))))
                                },
                                mouseenter: function(t) {
                                    i(this).closest("ul").find("li.active").removeClass("active");
                                    i(this).closest("li").addClass("active");
                                    n.helper.executeCallback.call(n, n.options.callback.onMouseEnter, [n.node, this, u, t])
                                },
                                mouseleave: function(t) {
                                    i(this).closest("li").removeClass("active");
                                    n.helper.executeCallback.call(n, n.options.callback.onMouseLeave, [n.node, this, u, t])
                                }
                            })
                        });
                        n.options.group ? (c = i(f).find('a[data-group="' + e + '"]:last').closest("li"), c[0] || (c = i(f).find('li[data-search-group="' + e + '"]')), i(l).insertAfter(c)) : i(f).append(l)
                    }(u, n.result[u], this)
                }
            });
            (this.buildBackdropLayout(), this.buildHintLayout(), this.options.callback.onLayoutBuiltBefore) && (u = this.helper.executeCallback.call(this, this.options.callback.onLayoutBuiltBefore, [this.node, this.query, this.result, r]), u instanceof jQuery && (r = u));
            this.resultContainer.html(r);
            this.options.callback.onLayoutBuiltAfter && this.helper.executeCallback.call(this, this.options.callback.onLayoutBuiltAfter, [this.node, this.query, this.result])
        },
        buildBackdropLayout: function() {
            this.options.backdrop && (this.backdrop.container || (this.backdrop.css = i.extend({
                opacity: .6,
                filter: "alpha(opacity=60)",
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                "z-index": 1040,
                "background-color": "#000"
            }, this.options.backdrop), this.backdrop.container = i("<div/>", {
                "class": this.options.selector.backdrop,
                css: this.backdrop.css
            }).insertAfter(this.container)), this.container.addClass("backdrop").css({
                "z-index": this.backdrop.css["z-index"] + 1,
                position: "relative"
            }))
        },
        buildHintLayout: function(n) {
            var f, s, e, t, r;
            if (this.options.hint) {
                var h = this,
                    o = "",
                    n = n || this.result,
                    u = this.query.toLowerCase();
                if (this.options.accent && (u = this.helper.removeAccent.call(this, u)), this.hintIndex = null, this.query.length >= this.options.minLength) {
                    if (this.hint.container || (this.hint.css = i.extend({
                            "border-color": "transparent",
                            position: "absolute",
                            top: 0,
                            display: "inline",
                            "z-index": -1,
                            float: "none",
                            color: "silver",
                            "box-shadow": "none",
                            cursor: "default",
                            "-webkit-user-select": "none",
                            "-moz-user-select": "none",
                            "-ms-user-select": "none",
                            "user-select": "none"
                        }, this.options.hint), this.hint.container = i("<input/>", {
                            type: this.node.attr("type"),
                            "class": this.node.attr("class"),
                            readonly: !0,
                            unselectable: "on",
                            tabindex: -1,
                            click: function() {
                                h.node.focus()
                            }
                        }).addClass(this.options.selector.hint).css(this.hint.css).insertAfter(this.node), this.node.parent().css({
                            position: "relative"
                        })), this.hint.container.css("color", this.hint.css.color), u)
                        for (t = 0; t < n.length; t++) {
                            for (s = n[t].group, f = this.options.source[s].display || this.options.display, r = 0; r < f.length; r++)
                                if (e = String(n[t][f[r]]).toLowerCase(), this.options.accent && (e = this.helper.removeAccent.call(this, e)), 0 === e.indexOf(u)) {
                                    o = String(n[t][f[r]]);
                                    this.hintIndex = t;
                                    break
                                } if (null !== this.hintIndex) break
                        }
                    this.hint.container.val(o.length > 0 && this.rawQuery + o.substring(this.query.length) || "")
                }
            }
        },
        buildDropdownLayout: function() {
            function f(n) {
                "*" === n.value ? delete this.filters.dropdown : this.filters.dropdown = n;
                this.container.removeClass("filter").find("." + this.options.selector.filterValue).html(n.display || n.value);
                this.node.trigger("dynamic" + u);
                this.node.focus()
            }
            var r, n, t;
            if (this.options.dropdownFilter) {
                if (n = this, "boolean" == typeof this.options.dropdownFilter) r = "all";
                else if ("string" == typeof this.options.dropdownFilter) r = this.options.dropdownFilter;
                else if (this.options.dropdownFilter instanceof Array)
                    for (t = 0; t < this.options.dropdownFilter.length; t++)
                        if ("*" === this.options.dropdownFilter[t].value && this.options.dropdownFilter[t].display) {
                            r = this.options.dropdownFilter[t].display;
                            break
                        } i("<span/>", {
                    "class": this.options.selector.filter,
                    html: function() {
                        i(this).append(i("<button/>", {
                            type: "button",
                            "class": n.options.selector.filterButton,
                            html: "<span class='" + n.options.selector.filterValue + "'>" + r + "<\/span> <span class='" + n.options.selector.dropdownCaret + "'><\/span>",
                            click: function(t) {
                                t.stopPropagation();
                                n.container.toggleClass("filter")
                            }
                        }));
                        i(this).append(i("<ul/>", {
                            "class": n.options.selector.dropdown,
                            html: function() {
                                var t = n.options.dropdownFilter,
                                    u, r;
                                if (~["string", "boolean"].indexOf(typeof n.options.dropdownFilter)) {
                                    t = [];
                                    for (u in n.options.source) n.options.source.hasOwnProperty(u) && t.push({
                                        key: "group",
                                        value: u
                                    });
                                    t.push({
                                        key: "group",
                                        value: "*",
                                        display: "string" == typeof n.options.dropdownFilter && n.options.dropdownFilter || "All"
                                    })
                                }
                                for (r = 0; r < t.length; r++) ! function(t, r, u) {
                                    (r.key || "*" === r.value) && r.value && ("*" === r.value && i(u).append(i("<li/>", {
                                        "class": "divider"
                                    })), i(u).append(i("<li/>", {
                                        html: i("<a/>", {
                                            href: "javascript:;",
                                            html: r.display || r.value,
                                            click: function(t) {
                                                t.preventDefault();
                                                f.apply(n, [r])
                                            }
                                        })
                                    })))
                                }(r, t[r], this)
                            }
                        }))
                    }
                }).insertAfter(n.container.find("." + n.options.selector.query))
            }
        },
        dynamicFilter: {
            validate: function(n) {
                var u, f, i = null,
                    r = null,
                    t;
                for (t in this.filters.dynamic)
                    if (this.filters.dynamic.hasOwnProperty(t) && (f = ~t.indexOf(".") ? this.helper.namespace(t, n, "get") : n[t], "|" !== this.filters.dynamic[t].modifier || i || (i = f == this.filters.dynamic[t].value || !1), "&" === this.filters.dynamic[t].modifier)) {
                        if (f != this.filters.dynamic[t].value) {
                            r = !1;
                            break
                        }
                        r = !0
                    } return u = i, null !== r && (u = r, r === !0 && null !== i && (u = i)), !!u
            },
            set: function(n, t) {
                var i = n.match(/^([|&])?(.+)/);
                t ? this.filters.dynamic[i[2]] = {
                    modifier: i[1] || "|",
                    value: t
                } : delete this.filters.dynamic[i[2]];
                this.searchResult();
                this.buildLayout()
            },
            bind: function() {
                if (this.options.dynamicFilter)
                    for (var n, t = this, r = 0; r < this.options.dynamicFilter.length; r++) n = this.options.dynamicFilter[r], "string" == typeof n.selector && (n.selector = i(n.selector)), n.selector instanceof jQuery && n.selector[0] && n.key && ! function(n) {
                        n.selector.off(u).on("change" + u, function() {
                            t.dynamicFilter.set.apply(t, [n.key, t.dynamicFilter.getValue(this)])
                        }).trigger("change" + u)
                    }(n)
            },
            getValue: function(n) {
                var t;
                return "SELECT" === n.tagName ? t = n.value : "INPUT" === n.tagName && ("checkbox" === n.type ? t = n.checked || null : "radio" === n.type && n.checked && (t = n.value)), t
            }
        },
        showLayout: function() {
            if (!this.container.hasClass("result") && (this.result.length || this.options.emptyTemplate || this.options.backdropOnFocus)) {
                var n = this;
                i("html").off(u).one("click" + u + " touchstart" + u, function() {
                    n.hideLayout()
                });
                this.container.addClass("result hint backdrop");
                this.helper.executeCallback.call(this, this.options.callback.onShowLayout, [this.node, this.query])
            }
        },
        hideLayout: function() {
            this.container.removeClass("result hint filter" + (this.options.backdropOnFocus && i(this.node).is(":focus") ? "" : " backdrop"));
            this.options.backdropOnFocus && this.container.hasClass("backdrop") || (i("html").off(u), this.helper.executeCallback.call(this, this.options.callback.onHideLayout, [this.node, this.query]))
        },
        resetLayout: function() {
            this.result = {};
            this.resultCount = 0;
            this.resultItemCount = 0;
            this.resultContainer && this.resultContainer.html("");
            this.options.hint && this.hint.container && this.hint.container.val("")
        },
        __construct: function() {
            this.extendOptions();
            this.unifySourceFormat() && (this.init(), this.delegateEvents(), this.buildDropdownLayout(), this.dynamicFilter.bind.apply(this), this.helper.executeCallback.call(this, this.options.callback.onReady, [this.node]))
        },
        helper: {
            isEmpty: function(n) {
                for (var t in n)
                    if (n.hasOwnProperty(t)) return !1;
                return !0
            },
            removeAccent: function(n) {
                if ("string" == typeof n) {
                    var t = this.options.accent || f;
                    return n.toLowerCase().replace(new RegExp("[" + t.from + "]", "g"), function(n) {
                        return t.to[t.from.indexOf(n)]
                    })
                }
            },
            slugify: function(n) {
                return n = String(n), "" !== n && (n = this.helper.removeAccent.call(this, n), n = n.replace(/[^-a-z0-9]+/g, "-").replace(/-+/g, "-").trim("-")), n
            },
            sort: function(n, t, i) {
                var r = function(t) {
                    for (var r = 0; r < n.length; r++)
                        if ("undefined" != typeof t[n[r]]) return i(t[n[r]]);
                    return t
                };
                return t = [-1, 1][+!!t],
                    function(n, i) {
                        return n = r(n), i = r(i), t * ((n > i) - (i > n))
                    }
            },
            replaceAt: function(n, t, i, r) {
                return n.substring(0, t) + r + n.substring(t + i)
            },
            highlight: function(n, t, i) {
                var f, u, r;
                for (n = String(n), f = i && this.helper.removeAccent.call(this, n) || n, u = [], t instanceof Array || (t = [t]), t.sort(function(n, t) {
                        return t.length - n.length
                    }), r = t.length - 1; r >= 0; r--) "" !== t[r].trim() ? t[r] = t[r].replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : t.splice(r, 1);
                for (f.replace(new RegExp("(?:" + t.join("|") + ")(?!([^<]+)?>)", "gi"), function(n, t, i) {
                        u.push({
                            offset: i,
                            length: n.length
                        })
                    }), r = u.length - 1; r >= 0; r--) n = this.helper.replaceAt(n, u[r].offset, u[r].length, "<strong>" + n.substr(u[r].offset, u[r].length) + "<\/strong>");
                return n
            },
            getCaret: function(n) {
                var r, i, u;
                return n.selectionStart ? n.selectionStart : t.selection ? (n.focus(), r = t.selection.createRange(), null == r) ? 0 : (i = n.createTextRange(), u = i.duplicate(), i.moveToBookmark(r.getBookmark()), u.setEndPoint("EndToStart", i), u.text.length) : 0
            },
            executeCallback: function(t, i) {
                if (!t) return !1;
                var r;
                if ("function" == typeof t) r = t;
                else if (("string" == typeof t || t instanceof Array) && ("string" == typeof t && (t = [t, []]), r = this.helper.namespace(t[0], n), "function" != typeof r)) return !1;
                return r.apply(this, (t[1] || []).concat(i ? i : [])) || !0
            },
            namespace: function(t, i, u, f) {
                if ("string" != typeof t || "" === t) return !1;
                for (var h = t.split("."), e = i || n, u = u || "get", l = f || {}, o = "", s = 0, c = h.length; c > s; s++) {
                    if (o = h[s], "undefined" == typeof e[o]) {
                        if (~["get", "delete"].indexOf(u)) return "undefined" != typeof f ? f : r;
                        e[o] = {}
                    }
                    if (~["set", "create", "delete"].indexOf(u) && s === c - 1) {
                        if ("set" !== u && "create" !== u) return delete e[o], !0;
                        e[o] = l
                    }
                    e = e[o]
                }
                return e
            },
            typeWatch: function() {
                var n = 0;
                return function(t, i) {
                    clearTimeout(n);
                    n = setTimeout(t, i)
                }
            }()
        }
    };
    i.fn.typeahead = i.typeahead = function(n) {
        return o.typeahead(this, n)
    };
    o = {
        typeahead: function(t, r) {
            if (r && r.source && "object" == typeof r.source) {
                if ("function" == typeof t) {
                    if (!r.input) return;
                    t = i(r.input)
                }
                if (t.length && "INPUT" === t[0].nodeName)
                    for (var u, f = 0; f < t.length; f++) u = 1 === t.length ? t : i(t.selector.split(",")[f].trim()), n.Typeahead[u.selector || r.input] = new e(u, r)
            }
        }
    };
    "sanitize" in String.prototype || (String.prototype.sanitize = function() {
        var n = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;"
        };
        return this.replace(/[&<>"'\/]/g, function(t) {
            return n[t]
        })
    });
    n.console = n.console || {
        log: function() {}
    };
    "trim" in String.prototype || (String.prototype.trim = function() {
        return this.replace(/^\s+/, "").replace(/\s+$/, "")
    });
    "indexOf" in Array.prototype || (Array.prototype.indexOf = function(n, t) {
        t === r && (t = 0);
        0 > t && (t += this.length);
        0 > t && (t = 0);
        for (var i = this.length; i > t; t++)
            if (t in this && this[t] === n) return t;
        return -1
    });
    Object.keys || (Object.keys = function(n) {
        var t, i = [];
        for (t in n) Object.prototype.hasOwnProperty.call(n, t) && i.push(t);
        return i
    })
}),
function(n, t) {
    function i(t, i) {
        var u, f, e, o = t.nodeName.toLowerCase();
        return "area" === o ? (u = t.parentNode, f = u.name, !t.href || !f || u.nodeName.toLowerCase() !== "map") ? !1 : (e = n("img[usemap=#" + f + "]")[0], !!e && r(e)) : (/input|select|textarea|button|object/.test(o) ? !t.disabled : "a" === o ? t.href || i : i) && r(t)
    }

    function r(t) {
        return n.expr.filters.visible(t) && !n(t).parents().andSelf().filter(function() {
            return n.css(this, "visibility") === "hidden"
        }).length
    }
    var u = 0,
        f = /^ui-id-\d+$/;
    (n.ui = n.ui || {}, n.ui.version) || (n.extend(n.ui, {
        version: "1.9.1",
        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            NUMPAD_ADD: 107,
            NUMPAD_DECIMAL: 110,
            NUMPAD_DIVIDE: 111,
            NUMPAD_ENTER: 108,
            NUMPAD_MULTIPLY: 106,
            NUMPAD_SUBTRACT: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }
    }), n.fn.extend({
        _focus: n.fn.focus,
        focus: function(t, i) {
            return typeof t == "number" ? this.each(function() {
                var r = this;
                setTimeout(function() {
                    n(r).focus();
                    i && i.call(r)
                }, t)
            }) : this._focus.apply(this, arguments)
        },
        scrollParent: function() {
            var t;
            return t = n.ui.ie && /(static|relative)/.test(this.css("position")) || /absolute/.test(this.css("position")) ? this.parents().filter(function() {
                return /(relative|absolute|fixed)/.test(n.css(this, "position")) && /(auto|scroll)/.test(n.css(this, "overflow") + n.css(this, "overflow-y") + n.css(this, "overflow-x"))
            }).eq(0) : this.parents().filter(function() {
                return /(auto|scroll)/.test(n.css(this, "overflow") + n.css(this, "overflow-y") + n.css(this, "overflow-x"))
            }).eq(0), /fixed/.test(this.css("position")) || !t.length ? n(document) : t
        },
        zIndex: function(i) {
            if (i !== t) return this.css("zIndex", i);
            if (this.length)
                for (var r = n(this[0]), u, f; r.length && r[0] !== document;) {
                    if (u = r.css("position"), (u === "absolute" || u === "relative" || u === "fixed") && (f = parseInt(r.css("zIndex"), 10), !isNaN(f) && f !== 0)) return f;
                    r = r.parent()
                }
            return 0
        },
        uniqueId: function() {
            return this.each(function() {
                this.id || (this.id = "ui-id-" + ++u)
            })
        },
        removeUniqueId: function() {
            return this.each(function() {
                f.test(this.id) && n(this).removeAttr("id")
            })
        }
    }), n("<a>").outerWidth(1).jquery || n.each(["Width", "Height"], function(i, r) {
        function u(t, i, r, u) {
            return n.each(o, function() {
                i -= parseFloat(n.css(t, "padding" + this)) || 0;
                r && (i -= parseFloat(n.css(t, "border" + this + "Width")) || 0);
                u && (i -= parseFloat(n.css(t, "margin" + this)) || 0)
            }), i
        }
        var o = r === "Width" ? ["Left", "Right"] : ["Top", "Bottom"],
            f = r.toLowerCase(),
            e = {
                innerWidth: n.fn.innerWidth,
                innerHeight: n.fn.innerHeight,
                outerWidth: n.fn.outerWidth,
                outerHeight: n.fn.outerHeight
            };
        n.fn["inner" + r] = function(i) {
            return i === t ? e["inner" + r].call(this) : this.each(function() {
                n(this).css(f, u(this, i) + "px")
            })
        };
        n.fn["outer" + r] = function(t, i) {
            return typeof t != "number" ? e["outer" + r].call(this, t) : this.each(function() {
                n(this).css(f, u(this, t, !0, i) + "px")
            })
        }
    }), n.extend(n.expr[":"], {
        data: n.expr.createPseudo ? n.expr.createPseudo(function(t) {
            return function(i) {
                return !!n.data(i, t)
            }
        }) : function(t, i, r) {
            return !!n.data(t, r[3])
        },
        focusable: function(t) {
            return i(t, !isNaN(n.attr(t, "tabindex")))
        },
        tabbable: function(t) {
            var r = n.attr(t, "tabindex"),
                u = isNaN(r);
            return (u || r >= 0) && i(t, !u)
        }
    }), n(function() {
        var i = document.body,
            t = i.appendChild(t = document.createElement("div"));
        t.offsetHeight;
        n.extend(t.style, {
            minHeight: "100px",
            height: "auto",
            padding: 0,
            borderWidth: 0
        });
        n.support.minHeight = t.offsetHeight === 100;
        n.support.selectstart = "onselectstart" in t;
        i.removeChild(t).style.display = "none"
    }), function() {
        var t = /msie ([\w.]+)/.exec(navigator.userAgent.toLowerCase()) || [];
        n.ui.ie = t.length ? !0 : !1;
        n.ui.ie6 = parseFloat(t[1], 10) === 6
    }(), n.fn.extend({
        disableSelection: function() {
            return this.bind((n.support.selectstart ? "selectstart" : "mousedown") + ".ui-disableSelection", function(n) {
                n.preventDefault()
            })
        },
        enableSelection: function() {
            return this.unbind(".ui-disableSelection")
        }
    }), n.extend(n.ui, {
        plugin: {
            add: function(t, i, r) {
                var u, f = n.ui[t].prototype;
                for (u in r) f.plugins[u] = f.plugins[u] || [], f.plugins[u].push([i, r[u]])
            },
            call: function(n, t, i) {
                var r, u = n.plugins[t];
                if (u && n.element[0].parentNode && n.element[0].parentNode.nodeType !== 11)
                    for (r = 0; r < u.length; r++) n.options[u[r][0]] && u[r][1].apply(n.element, i)
            }
        },
        contains: n.contains,
        hasScroll: function(t, i) {
            if (n(t).css("overflow") === "hidden") return !1;
            var r = i && i === "left" ? "scrollLeft" : "scrollTop",
                u = !1;
            return t[r] > 0 ? !0 : (t[r] = 1, u = t[r] > 0, t[r] = 0, u)
        },
        isOverAxis: function(n, t, i) {
            return n > t && n < t + i
        },
        isOver: function(t, i, r, u, f, e) {
            return n.ui.isOverAxis(t, r, f) && n.ui.isOverAxis(i, u, e)
        }
    }))
}(jQuery),
function(n, t) {
    function e() {
        this.debug = !1;
        this._curInst = null;
        this._keyEvent = !1;
        this._disabledInputs = [];
        this._datepickerShowing = !1;
        this._inDialog = !1;
        this._mainDivId = "ui-datepicker-div";
        this._inlineClass = "ui-datepicker-inline";
        this._appendClass = "ui-datepicker-append";
        this._triggerClass = "ui-datepicker-trigger";
        this._dialogClass = "ui-datepicker-dialog";
        this._disableClass = "ui-datepicker-disabled";
        this._unselectableClass = "ui-datepicker-unselectable";
        this._currentClass = "ui-datepicker-current-day";
        this._dayOverClass = "ui-datepicker-days-cell-over";
        this.regional = [];
        this.regional[""] = {
            calendar: Date,
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            weekHeader: "Wk",
            dateFormat: "yy-mm-dd",
            firstDay: 0,
            isRTL: !1,
            showMonthAfterYear: !1,
            yearSuffix: ""
        };
        this._defaults = {
            showOn: "focus",
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: !1,
            hideIfNoPrevNext: !1,
            navigationAsDateFormat: !1,
            gotoCurrent: !1,
            changeMonth: !1,
            changeYear: !1,
            yearRange: "c-10:c+10",
            showOtherMonths: !1,
            selectOtherMonths: !1,
            showWeek: !1,
            calculateWeek: this.iso8601Week,
            shortYearCutoff: "+10",
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            beforeShow: null,
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: !0,
            showButtonPanel: !1,
            autoSize: !1,
            disabled: !1
        };
        n.extend(this._defaults, this.regional[""]);
        this.dpDiv = o(n('<div id="' + this._mainDivId + '" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"><\/div>'))
    }

    function o(t) {
        var i = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return t.delegate(i, "mouseout", function() {
            n(this).removeClass("ui-state-hover");
            this.className.indexOf("ui-datepicker-prev") != -1 && n(this).removeClass("ui-datepicker-prev-hover");
            this.className.indexOf("ui-datepicker-next") != -1 && n(this).removeClass("ui-datepicker-next-hover")
        }).delegate(i, "mouseover", function() {
            n.datepicker._isDisabledDatepicker(f.inline ? t.parent()[0] : f.input[0]) || (n(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), n(this).addClass("ui-state-hover"), this.className.indexOf("ui-datepicker-prev") != -1 && n(this).addClass("ui-datepicker-prev-hover"), this.className.indexOf("ui-datepicker-next") != -1 && n(this).addClass("ui-datepicker-next-hover"))
        })
    }

    function u(i, r) {
        n.extend(i, r);
        for (var u in r)(r[u] == null || r[u] == t) && (i[u] = r[u]);
        return i
    }
    n.extend(n.ui, {
        datepicker: {
            version: "1.9.1"
        }
    });
    var i = "datepicker",
        r = (new Date).getTime(),
        f;
    n.extend(e.prototype, {
        markerClassName: "hasDatepicker",
        maxRows: 4,
        log: function() {
            this.debug && console.log.apply("", arguments)
        },
        _widgetDatepicker: function() {
            return this.dpDiv
        },
        setDefaults: function(n) {
            return u(this._defaults, n || {}), this
        },
        _attachDatepicker: function(target, settings) {
            var inlineSettings = null,
                attrName, attrValue, nodeName, inline, inst, regional;
            for (attrName in this._defaults)
                if (attrValue = target.getAttribute("date:" + attrName), attrValue) {
                    inlineSettings = inlineSettings || {};
                    try {
                        inlineSettings[attrName] = eval(attrValue)
                    } catch (err) {
                        inlineSettings[attrName] = attrValue
                    }
                } nodeName = target.nodeName.toLowerCase();
            inline = nodeName == "div" || nodeName == "span";
            target.id || (this.uuid += 1, target.id = "dp" + this.uuid);
            inst = this._newInst(n(target), inline);
            regional = n.extend({}, settings && this.regional[settings.regional] || {});
            inst.settings = n.extend(regional, settings || {}, inlineSettings || {});
            nodeName == "input" ? this._connectDatepicker(target, inst) : inline && this._inlineDatepicker(target, inst)
        },
        _newInst: function(t, i) {
            var r = t[0].id.replace(/([^A-Za-z0-9_-])/g, "\\\\$1");
            return {
                id: r,
                input: t,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: i,
                dpDiv: i ? o(n('<div class="' + this._inlineClass + ' ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"><\/div>')) : this.dpDiv
            }
        },
        _connectDatepicker: function(t, r) {
            var u = n(t);
            (r.append = n([]), r.trigger = n([]), u.hasClass(this.markerClassName)) || (this._attachments(u, r), u.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp).bind("setData.datepicker", function(n, t, i) {
                r.settings[t] = i
            }).bind("getData.datepicker", function(n, t) {
                return this._get(r, t)
            }), this._autoSize(r), n.data(t, i, r), r.settings.disabled && this._disableDatepicker(t))

        },
        _attachments: function(t, i) {
            var e = this._get(i, "appendText"),
                o = !1,
                u, r, f;
            i.append && i.append.remove();
            e && (i.append = n('<span class="' + this._appendClass + '">' + e + "<\/span>"), t[o ? "before" : "after"](i.append));
            t.unbind("focus", this._showDatepicker);
            i.trigger && i.trigger.remove();
            u = this._get(i, "showOn");
            (u == "focus" || u == "both") && t.focus(this._showDatepicker);
            (u == "button" || u == "both") && (r = this._get(i, "buttonText"), f = this._get(i, "buttonImage"), i.trigger = n(this._get(i, "buttonImageOnly") ? n("<img/>").addClass(this._triggerClass).attr({
                src: f,
                alt: r,
                title: r
            }) : n('<button type="button"><\/button>').addClass(this._triggerClass).html(f == "" ? r : n("<img/>").attr({
                src: f,
                alt: r,
                title: r
            }))), t[o ? "before" : "after"](i.trigger), i.trigger.click(function() {
                return n.datepicker._datepickerShowing && n.datepicker._lastInput == t[0] ? n.datepicker._hideDatepicker() : n.datepicker._datepickerShowing && n.datepicker._lastInput != t[0] ? (n.datepicker._hideDatepicker(), n.datepicker._showDatepicker(t[0])) : n.datepicker._showDatepicker(t[0]), !1
            }))
        },
        _autoSize: function(n) {
            var t, i, r;
            this._get(n, "autoSize") && !n.inline && (t = new Date(2009, 11, 20), i = this._get(n, "dateFormat"), i.match(/[DM]/) && (r = function(n) {
                for (var i = 0, r = 0, t = 0; t < n.length; t++) n[t].length > i && (i = n[t].length, r = t);
                return r
            }, t.setMonth(r(this._get(n, i.match(/MM/) ? "monthNames" : "monthNamesShort"))), t.setDate(r(this._get(n, i.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - t.getDay())), n.input.attr("size", this._formatDate(n, t).length))
        },
        _inlineDatepicker: function(t, r) {
            var u = n(t);
            u.hasClass(this.markerClassName) || (u.addClass(this.markerClassName).append(r.dpDiv).bind("setData.datepicker", function(n, t, i) {
                r.settings[t] = i
            }).bind("getData.datepicker", function(n, t) {
                return this._get(r, t)
            }), n.data(t, i, r), this._setDate(r, this._getDefaultDate(r), !0), this._updateDatepicker(r), this._updateAlternate(r), r.settings.disabled && this._disableDatepicker(t), r.dpDiv.css("display", "block"))
        },
        _dialogDatepicker: function(t, r, f, e, o) {
            var s = this._dialogInst,
                h;
            if (s || (this.uuid += 1, h = "dp" + this.uuid, this._dialogInput = n('<input type="text" id="' + h + '" style="position: absolute; top: -100px; width: 0px;"/>'), this._dialogInput.keydown(this._doKeyDown), n("body").append(this._dialogInput), s = this._dialogInst = this._newInst(this._dialogInput, !1), s.settings = {}, n.data(this._dialogInput[0], i, s)), u(s.settings, e || {}), r = r && r.constructor == Date ? this._formatDate(s, r) : r, this._dialogInput.val(r), this._pos = o ? o.length ? o : [o.pageX, o.pageY] : null, !this._pos) {
                var c = document.documentElement.clientWidth,
                    l = document.documentElement.clientHeight,
                    a = document.documentElement.scrollLeft || document.body.scrollLeft,
                    v = document.documentElement.scrollTop || document.body.scrollTop;
                this._pos = [c / 2 - 100 + a, l / 2 - 150 + v]
            }
            return this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), s.settings.onSelect = f, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), n.blockUI && n.blockUI(this.dpDiv), n.data(this._dialogInput[0], i, s), this
        },
        _destroyDatepicker: function(t) {
            var u = n(t),
                f = n.data(t, i),
                r;
            u.hasClass(this.markerClassName) && (r = t.nodeName.toLowerCase(), n.removeData(t, i), r == "input" ? (f.append.remove(), f.trigger.remove(), u.removeClass(this.markerClassName).unbind("focus", this._showDatepicker).unbind("keydown", this._doKeyDown).unbind("keypress", this._doKeyPress).unbind("keyup", this._doKeyUp)) : (r == "div" || r == "span") && u.removeClass(this.markerClassName).empty())
        },
        _enableDatepicker: function(t) {
            var f = n(t),
                e = n.data(t, i),
                r, u;
            f.hasClass(this.markerClassName) && (r = t.nodeName.toLowerCase(), r == "input" ? (t.disabled = !1, e.trigger.filter("button").each(function() {
                this.disabled = !1
            }).end().filter("img").css({
                opacity: "1.0",
                cursor: ""
            })) : (r == "div" || r == "span") && (u = f.children("." + this._inlineClass), u.children().removeClass("ui-state-disabled"), u.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)), this._disabledInputs = n.map(this._disabledInputs, function(n) {
                return n == t ? null : n
            }))
        },
        _disableDatepicker: function(t) {
            var f = n(t),
                e = n.data(t, i),
                r, u;
            f.hasClass(this.markerClassName) && (r = t.nodeName.toLowerCase(), r == "input" ? (t.disabled = !0, e.trigger.filter("button").each(function() {
                this.disabled = !0
            }).end().filter("img").css({
                opacity: "0.5",
                cursor: "default"
            })) : (r == "div" || r == "span") && (u = f.children("." + this._inlineClass), u.children().addClass("ui-state-disabled"), u.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)), this._disabledInputs = n.map(this._disabledInputs, function(n) {
                return n == t ? null : n
            }), this._disabledInputs[this._disabledInputs.length] = t)
        },
        _isDisabledDatepicker: function(n) {
            if (!n) return !1;
            for (var t = 0; t < this._disabledInputs.length; t++)
                if (this._disabledInputs[t] == n) return !0;
            return !1
        },
        _getInst: function(t) {
            try {
                return n.data(t, i)
            } catch (r) {
                throw "Missing instance data for this datepicker";
            }
        },
        _optionDatepicker: function(i, r, f) {
            var e = this._getInst(i),
                o;
            if (arguments.length == 2 && typeof r == "string") return r == "defaults" ? n.extend({}, n.datepicker._defaults) : e ? r == "all" ? n.extend({}, e.settings) : this._get(e, r) : null;
            if (o = r || {}, typeof r == "string" && (o = {}, o[r] = f), e) {
                this._curInst == e && this._hideDatepicker();
                var c = this._getDateDatepicker(i, !0),
                    s = this._getMinMaxDate(e, "min"),
                    h = this._getMinMaxDate(e, "max");
                u(e.settings, o);
                s !== null && o.dateFormat !== t && o.minDate === t && (e.settings.minDate = this._formatDate(e, s));
                h !== null && o.dateFormat !== t && o.maxDate === t && (e.settings.maxDate = this._formatDate(e, h));
                this._attachments(n(i), e);
                this._autoSize(e);
                this._setDate(e, c);
                this._updateAlternate(e);
                this._updateDatepicker(e)
            }
        },
        _changeDatepicker: function(n, t, i) {
            this._optionDatepicker(n, t, i)
        },
        _refreshDatepicker: function(n) {
            var t = this._getInst(n);
            t && this._updateDatepicker(t)
        },
        _setDateDatepicker: function(n, t) {
            var i = this._getInst(n);
            i && (this._setDate(i, t), this._updateDatepicker(i), this._updateAlternate(i))
        },
        _getDateDatepicker: function(n, t) {
            var i = this._getInst(n);
            return i && !i.inline && this._setDateFromField(i, t), i ? this._getDate(i) : null
        },
        _doKeyDown: function(t) {
            var i = n.datepicker._getInst(t.target),
                r = !0,
                e = i.dpDiv.is(".ui-datepicker-rtl"),
                u, f, o;
            if (i._keyEvent = !0, n.datepicker._datepickerShowing) switch (t.keyCode) {
                case 9:
                    n.datepicker._hideDatepicker();
                    r = !1;
                    break;
                case 13:
                    return u = n("td." + n.datepicker._dayOverClass + ":not(." + n.datepicker._currentClass + ")", i.dpDiv), u[0] && n.datepicker._selectDay(t.target, i.selectedMonth, i.selectedYear, u[0]), f = n.datepicker._get(i, "onSelect"), f ? (o = n.datepicker._formatDate(i), f.apply(i.input ? i.input[0] : null, [o, i])) : n.datepicker._hideDatepicker(), !1;
                case 27:
                    n.datepicker._hideDatepicker();
                    break;
                case 33:
                    n.datepicker._adjustDate(t.target, t.ctrlKey ? -n.datepicker._get(i, "stepBigMonths") : -n.datepicker._get(i, "stepMonths"), "M");
                    break;
                case 34:
                    n.datepicker._adjustDate(t.target, t.ctrlKey ? +n.datepicker._get(i, "stepBigMonths") : +n.datepicker._get(i, "stepMonths"), "M");
                    break;
                case 35:
                    (t.ctrlKey || t.metaKey) && n.datepicker._clearDate(t.target);
                    r = t.ctrlKey || t.metaKey;
                    break;
                case 36:
                    (t.ctrlKey || t.metaKey) && n.datepicker._gotoToday(t.target);
                    r = t.ctrlKey || t.metaKey;
                    break;
                case 37:
                    (t.ctrlKey || t.metaKey) && n.datepicker._adjustDate(t.target, e ? 1 : -1, "D");
                    r = t.ctrlKey || t.metaKey;
                    t.originalEvent.altKey && n.datepicker._adjustDate(t.target, t.ctrlKey ? -n.datepicker._get(i, "stepBigMonths") : -n.datepicker._get(i, "stepMonths"), "M");
                    break;
                case 38:
                    (t.ctrlKey || t.metaKey) && n.datepicker._adjustDate(t.target, -7, "D");
                    r = t.ctrlKey || t.metaKey;
                    break;
                case 39:
                    (t.ctrlKey || t.metaKey) && n.datepicker._adjustDate(t.target, e ? -1 : 1, "D");
                    r = t.ctrlKey || t.metaKey;
                    t.originalEvent.altKey && n.datepicker._adjustDate(t.target, t.ctrlKey ? +n.datepicker._get(i, "stepBigMonths") : +n.datepicker._get(i, "stepMonths"), "M");
                    break;
                case 40:
                    (t.ctrlKey || t.metaKey) && n.datepicker._adjustDate(t.target, 7, "D");
                    r = t.ctrlKey || t.metaKey;
                    break;
                default:
                    r = !1
            } else t.keyCode == 36 && t.ctrlKey ? n.datepicker._showDatepicker(this) : r = !1;
            r && (t.preventDefault(), t.stopPropagation())
        },
        _doKeyPress: function(i) {
            var f = n.datepicker._getInst(i.target),
                r, u;
            if (n.datepicker._get(f, "constrainInput")) return r = n.datepicker._possibleChars(n.datepicker._get(f, "dateFormat")), u = String.fromCharCode(i.charCode == t ? i.keyCode : i.charCode), i.ctrlKey || i.metaKey || u < " " || !r || r.indexOf(u) > -1
        },
        _doKeyUp: function(t) {
            var i = n.datepicker._getInst(t.target),
                r;
            if (i.input.val() != i.lastVal) try {
                r = n.datepicker.parseDate(n.datepicker._get(i, "dateFormat"), i.input ? i.input.val() : null, n.datepicker._getFormatConfig(i));
                r && (n.datepicker._setDateFromField(i), n.datepicker._updateAlternate(i), n.datepicker._updateDatepicker(i))
            } catch (u) {
                n.datepicker.log(u)
            }
            return !0
        },
        _showDatepicker: function(t) {
            var i, o, s, f, e;
            if ((t = t.target || t, t.nodeName.toLowerCase() != "input" && (t = n("input", t.parentNode)[0]), !n.datepicker._isDisabledDatepicker(t) && n.datepicker._lastInput != t) && (i = n.datepicker._getInst(t), n.datepicker._curInst && n.datepicker._curInst != i && (n.datepicker._curInst.dpDiv.stop(!0, !0), i && n.datepicker._datepickerShowing && n.datepicker._hideDatepicker(n.datepicker._curInst.input[0])), o = n.datepicker._get(i, "beforeShow"), s = o ? o.apply(t, [t, i]) : {}, s !== !1) && (u(i.settings, s), i.lastVal = null, n.datepicker._lastInput = t, n.datepicker._setDateFromField(i), n.datepicker._inDialog && (t.value = ""), n.datepicker._pos || (n.datepicker._pos = n.datepicker._findPos(t), n.datepicker._pos[1] += t.offsetHeight), f = !1, n(t).parents().each(function() {
                    return f |= n(this).css("position") == "fixed", !f
                }), e = {
                    left: n.datepicker._pos[0],
                    top: n.datepicker._pos[1]
                }, n.datepicker._pos = null, i.dpDiv.empty(), i.dpDiv.css({
                    position: "absolute",
                    display: "block",
                    top: "-1000px"
                }), n.datepicker._updateDatepicker(i), e = n.datepicker._checkOffset(i, e, f), i.dpDiv.css({
                    position: n.datepicker._inDialog && n.blockUI ? "static" : f ? "fixed" : "absolute",
                    display: "none",
                    left: e.left + "px",
                    top: e.top + "px"
                }), !i.inline)) {
                var r = n.datepicker._get(i, "showAnim"),
                    h = n.datepicker._get(i, "duration"),
                    c = function() {
                        var r = i.dpDiv.find("iframe.ui-datepicker-cover"),
                            t;
                        !r.length || (t = n.datepicker._getBorders(i.dpDiv), r.css({
                            left: -t[0],
                            top: -t[1],
                            width: i.dpDiv.outerWidth(),
                            height: i.dpDiv.outerHeight()
                        }))
                    };
                i.dpDiv.zIndex(n(t).zIndex() + 1);
                n.datepicker._datepickerShowing = !0;
                n.effects && (n.effects.effect[r] || n.effects[r]) ? i.dpDiv.show(r, n.datepicker._get(i, "showOptions"), h, c) : i.dpDiv[r || "show"](r ? h : null, c);
                r && h || c();
                i.input.is(":visible") && !i.input.is(":disabled") && i.input.focus();
                n.datepicker._curInst = i
            }
        },
        _updateDatepicker: function(t) {
            var i, r, o;
            this.maxRows = 4;
            i = n.datepicker._getBorders(t.dpDiv);
            f = t;
            t.dpDiv.empty().append(this._generateHTML(t));
            this._attachHandlers(t);
            r = t.dpDiv.find("iframe.ui-datepicker-cover");
            !r.length || r.css({
                left: -i[0],
                top: -i[1],
                width: t.dpDiv.outerWidth(),
                height: t.dpDiv.outerHeight()
            });
            t.dpDiv.find("." + this._dayOverClass + " a").mouseover();
            var u = this._getNumberOfMonths(t),
                e = u[1];
            t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
            e > 1 && t.dpDiv.addClass("ui-datepicker-multi-" + e).css("width", 17 * e + "em");
            t.dpDiv[(u[0] != 1 || u[1] != 1 ? "add" : "remove") + "Class"]("ui-datepicker-multi");
            t.dpDiv[(this._get(t, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl");
            t == n.datepicker._curInst && n.datepicker._datepickerShowing && t.input && t.input.is(":visible") && !t.input.is(":disabled") && t.input[0] != document.activeElement && t.input.focus();
            t.yearshtml && (o = t.yearshtml, setTimeout(function() {
                o === t.yearshtml && t.yearshtml && t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml);
                o = t.yearshtml = null
            }, 0))
        },
        _getBorders: function(n) {
            var t = function(n) {
                return {
                    thin: 1,
                    medium: 2,
                    thick: 3
                } [n] || n
            };
            return [parseFloat(t(n.css("border-left-width"))), parseFloat(t(n.css("border-top-width")))]
        },
        _checkOffset: function(t, i, r) {
            var u = t.dpDiv.outerWidth(),
                f = t.dpDiv.outerHeight(),
                h = t.input ? t.input.outerWidth() : 0,
                o = t.input ? t.input.outerHeight() : 0,
                e = document.documentElement.clientWidth + (r ? 0 : n(document).scrollLeft()),
                s = document.documentElement.clientHeight + (r ? 0 : n(document).scrollTop());
            return i.left -= this._get(t, "isRTL") ? u - h : 0, i.left -= r && i.left == t.input.offset().left ? n(document).scrollLeft() : 0, i.top -= r && i.top == t.input.offset().top + o ? n(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + u > e && e > u ? Math.abs(i.left + u - e) : 0), i.top -= Math.min(i.top, i.top + f > s && s > f ? Math.abs(f + o) : 0), i
        },
        _findPos: function(t) {
            for (var r = this._getInst(t), u = this._get(r, "isRTL"), i; t && (t.type == "hidden" || t.nodeType != 1 || n.expr.filters.hidden(t));) t = t[u ? "previousSibling" : "nextSibling"];
            return i = n(t).offset(), [i.left, i.top]
        },
        _hideDatepicker: function(t) {
            var r = this._curInst,
                e;
            if (r && (!t || r == n.data(t, i)) && this._datepickerShowing) {
                var u = this._get(r, "showAnim"),
                    o = this._get(r, "duration"),
                    f = function() {
                        n.datepicker._tidyDialog(r)
                    };
                n.effects && (n.effects.effect[u] || n.effects[u]) ? r.dpDiv.hide(u, n.datepicker._get(r, "showOptions"), o, f) : r.dpDiv[u == "slideDown" ? "slideUp" : u == "fadeIn" ? "fadeOut" : "hide"](u ? o : null, f);
                u || f();
                this._datepickerShowing = !1;
                e = this._get(r, "onClose");
                e && e.apply(r.input ? r.input[0] : null, [r.input ? r.input.val() : "", r]);
                this._lastInput = null;
                this._inDialog && (this._dialogInput.css({
                    position: "absolute",
                    left: "0",
                    top: "-100px"
                }), n.blockUI && (n.unblockUI(), n("body").append(this.dpDiv)));
                this._inDialog = !1
            }
        },
        _tidyDialog: function(n) {
            n.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")
        },
        _checkExternalClick: function(t) {
            if (n.datepicker._curInst) {
                var i = n(t.target),
                    r = n.datepicker._getInst(i[0]);
                (i[0].id == n.datepicker._mainDivId || i.parents("#" + n.datepicker._mainDivId).length != 0 || i.hasClass(n.datepicker.markerClassName) || i.closest("." + n.datepicker._triggerClass).length || !n.datepicker._datepickerShowing || n.datepicker._inDialog && n.blockUI) && (!i.hasClass(n.datepicker.markerClassName) || n.datepicker._curInst == r) || n.datepicker._hideDatepicker()
            }
        },
        _adjustDate: function(t, i, r) {
            var f = n(t),
                u = this._getInst(f[0]);
            this._isDisabledDatepicker(f[0]) || (this._adjustInstDate(u, i + (r == "M" ? this._get(u, "showCurrentAtPos") : 0), r), this._updateDatepicker(u))
        },
        _gotoToday: function(t) {
            var u = n(t),
                i = this._getInst(u[0]),
                r;
            this._get(i, "gotoCurrent") && i.currentDay ? (i.selectedDay = i.currentDay, i.drawMonth = i.selectedMonth = i.currentMonth, i.drawYear = i.selectedYear = i.currentYear) : (r = new this.CDate, i.selectedDay = r.getDate(), i.drawMonth = i.selectedMonth = r.getMonth(), i.drawYear = i.selectedYear = r.getFullYear());
            this._notifyChange(i);
            this._adjustDate(u)
        },
        _selectMonthYear: function(t, i, r) {
            var f = n(t),
                u = this._getInst(f[0]);
            u["selected" + (r == "M" ? "Month" : "Year")] = u["draw" + (r == "M" ? "Month" : "Year")] = parseInt(i.options[i.selectedIndex].value, 10);
            this._notifyChange(u);
            this._adjustDate(f)
        },
        _selectDay: function(t, i, r, u) {
            var e = n(t),
                f;

            n(u).hasClass(this._unselectableClass) || this._isDisabledDatepicker(e[0]) || (f = this._getInst(e[0]), f.selectedDay = f.currentDay = n("a", u).html(), f.selectedMonth = f.currentMonth = i, f.selectedYear = f.currentYear = r, this._selectDate(t, this._formatDate(f, f.currentDay, f.currentMonth, f.currentYear)))

            if(this._getInst(e[0]).id == 'regds_dept_date_local'){
               $('.cbox-count-nafar').show();
               $('.fa-caret-down.down-count-nafar').addClass('fa-caret-up');
            }
            if(this._getInst(e[0]).id == 'regds_dept_date_Portal'){
               $('.cbox-count-nafar').show();
               $('.fa-caret-down.down-count-nafar').addClass('fa-caret-up');
            }
            if(this._getInst(e[0]).id == 'gds_dept_date_Portal'){
                if(!$('#regds_dept_date_Portal').is(':disabled')){


                $('#regds_dept_date_Portal').trigger('focus');
                }
                else{
                    $('.cbox-count-nafar').show();
                    $('.fa-caret-down.down-count-nafar').addClass('fa-caret-up');
                }


            }


            if(this._getInst(e[0]).id == 'startDateForHotelLocal'){
                $('#endDateForHotelLocal').trigger('focus')

            }
            if(this._getInst(e[0]).id == 'startDateForExternalHotelLocal'){
                $('#endDateForExternalHotelLocal').trigger('focus')

            }

            if(this._getInst(e[0]).id == 'endDateForExternalHotelLocal'){
                $('.myhotels-rooms').addClass('active_p');

            }
            if(this._getInst(e[0]).id == 'endDateForHotelLocal'){
                $('.hotel_local-rooms').addClass('active_p');

            }
        },
        _clearDate: function(t) {
            var i = n(t),
                r = this._getInst(i[0]);
            this._selectDate(i, "")
        },
        _selectDate: function(t, i) {
            var f = n(t),
                r = this._getInst(f[0]),
                u;
            i = i != null ? i : this._formatDate(r);
            r.input && r.input.val(i);
            this._updateAlternate(r);
            u = this._get(r, "onSelect");
            u ? u.apply(r.input ? r.input[0] : null, [i, r]) : r.input && r.input.trigger("change");
            r.inline ? this._updateDatepicker(r) : (this._hideDatepicker(), this._lastInput = r.input[0], typeof r.input[0] != "object" && r.input.focus(), this._lastInput = null)
        },
        _updateAlternate: function(t) {
            var i = this._get(t, "altField");
            if (i) {
                var r = this._get(t, "altFormat") || this._get(t, "dateFormat"),
                    u = this._getDate(t),
                    f = this.formatDate(r, u, this._getFormatConfig(t));
                n(i).each(function() {
                    n(this).val(f)
                })
            }
        },
        noWeekends: function(n) {
            var t = n.getDay();
            return [t > 0 && t < 6, ""]
        },
        iso8601Week: function(n) {
            var t = new Date(n.getTime()),
                i;
            return t.setDate(t.getDate() + 4 - (t.getDay() || 7)), i = t.getTime(), t.setMonth(0), t.setDate(1), Math.floor(Math.round((i - t) / 864e5) / 7) + 1
        },
        parseDate: function(t, i, r) {
            var c, s, w, b, u;
            if (t == null || i == null) throw "Invalid arguments";
            if (i = typeof i == "object" ? i.toString() : i + "", i == "") return null;
            c = (r ? r.shortYearCutoff : null) || this._defaults.shortYearCutoff;
            c = typeof c != "string" ? c : (new this.CDate).getFullYear() % 100 + parseInt(c, 10);
            var d = (r ? r.dayNamesShort : null) || this._defaults.dayNamesShort,
                g = (r ? r.dayNames : null) || this._defaults.dayNames,
                nt = (r ? r.monthNamesShort : null) || this._defaults.monthNamesShort,
                tt = (r ? r.monthNames : null) || this._defaults.monthNames,
                f = -1,
                o = -1,
                h = -1,
                v = -1,
                y = !1,
                a = function(n) {
                    var i = s + 1 < t.length && t.charAt(s + 1) == n;
                    return i && s++, i
                },
                l = function(n) {
                    var r = a(n),
                        u = n == "@" ? 14 : n == "!" ? 20 : n == "y" && r ? 4 : n == "o" ? 3 : 2,
                        f = new RegExp("^\\d{1," + u + "}"),
                        t = i.substring(e).match(f);
                    if (!t) throw "Missing number at position " + e;
                    return e += t[0].length, parseInt(t[0], 10)
                },
                k = function(t, r, u) {
                    var o = n.map(a(t) ? u : r, function(n, t) {
                            return [
                                [t, n]
                            ]
                        }).sort(function(n, t) {
                            return -(n[1].length - t[1].length)
                        }),
                        f = -1;
                    if (n.each(o, function(n, t) {
                            var r = t[1];
                            if (i.substr(e, r.length).toLowerCase() == r.toLowerCase()) return f = t[0], e += r.length, !1
                        }), f != -1) return f + 1;
                    throw "Unknown name at position " + e;
                },
                p = function() {
                    if (i.charAt(e) != t.charAt(s)) throw "Unexpected literal at position " + e;
                    e++
                },
                e = 0;
            for (s = 0; s < t.length; s++)
                if (y) t.charAt(s) != "'" || a("'") ? p() : y = !1;
                else switch (t.charAt(s)) {
                    case "d":
                        h = l("d");
                        break;
                    case "D":
                        k("D", d, g);
                        break;
                    case "o":
                        v = l("o");
                        break;
                    case "m":
                        o = l("m");
                        break;
                    case "M":
                        o = k("M", nt, tt);
                        break;
                    case "y":
                        f = l("y");
                        break;
                    case "@":
                        u = new this.CDate(l("@"));
                        f = u.getFullYear();
                        o = u.getMonth() + 1;
                        h = u.getDate();
                        break;
                    case "!":
                        u = new Date((l("!") - this._ticksTo1970) / 1e4);
                        f = u.getFullYear();
                        o = u.getMonth() + 1;
                        h = u.getDate();
                        break;
                    case "'":
                        a("'") ? p() : y = !0;
                        break;
                    default:
                        p()
                }
            if (e < i.length && (w = i.substr(e), !/^\s+/.test(w))) throw "Extra/unparsed characters found in date: " + w;
            if (f == -1 ? f = (new this.CDate).getFullYear() : f < 100 && (f += (new this.CDate).getFullYear() - (new this.CDate).getFullYear() % 100 + (f <= c ? 0 : -100)), v > -1) {
                o = 1;
                h = v;
                do {
                    if (b = this._getDaysInMonth(f, o - 1), h <= b) break;
                    o++;
                    h -= b
                } while (1)
            }
            if (u = this._daylightSavingAdjust(new this.CDate(f, o - 1, h)), u.getFullYear() != f || u.getMonth() + 1 != o || u.getDate() != h) throw "Invalid date";
            return u
        },
        ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: (718685 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 864e9,
        formatDate: function(n, t, i) {
            var u;
            if (!t) return "";
            var h = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort,
                c = (i ? i.dayNames : null) || this._defaults.dayNames,
                l = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort,
                a = (i ? i.monthNames : null) || this._defaults.monthNames,
                f = function(t) {
                    var i = u + 1 < n.length && n.charAt(u + 1) == t;
                    return i && u++, i
                },
                e = function(n, t, i) {
                    var r = "" + t;
                    if (f(n))
                        while (r.length < i) r = "0" + r;
                    return r
                },
                s = function(n, t, i, r) {
                    return f(n) ? r[t] : i[t]
                },
                r = "",
                o = !1;
            if (t)
                for (u = 0; u < n.length; u++)
                    if (o) n.charAt(u) != "'" || f("'") ? r += n.charAt(u) : o = !1;
                    else switch (n.charAt(u)) {
                        case "d":
                            r += e("d", t.getDate(), 2);
                            break;
                        case "D":
                            r += s("D", t.getDay(), h, c);
                            break;
                        case "o":
                            r += e("o", Math.round((new this.CDate(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new this.CDate(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                            break;
                        case "m":
                            r += e("m", t.getMonth() + 1, 2);
                            break;
                        case "M":
                            r += s("M", t.getMonth(), l, a);
                            break;
                        case "y":
                            r += f("y") ? t.getFullYear() : (t.getYear() % 100 < 10 ? "0" : "") + t.getYear() % 100;
                            break;
                        case "@":
                            r += t.getTime();
                            break;
                        case "!":
                            r += t.getTime() * 1e4 + this._ticksTo1970;
                            break;
                        case "'":
                            f("'") ? r += "'" : o = !0;
                            break;
                        default:
                            r += n.charAt(u)
                    }
            return r
        },
        _possibleChars: function(n) {
            for (var i = "", r = !1, u = function(i) {
                    var r = t + 1 < n.length && n.charAt(t + 1) == i;
                    return r && t++, r
                }, t = 0; t < n.length; t++)
                if (r) n.charAt(t) != "'" || u("'") ? i += n.charAt(t) : r = !1;
                else switch (n.charAt(t)) {
                    case "d":
                    case "m":
                    case "y":
                    case "@":
                        i += "0123456789";
                        break;
                    case "D":
                    case "M":
                        return null;
                    case "'":
                        u("'") ? i += "'" : r = !0;
                        break;
                    default:
                        i += n.charAt(t)
                }
            return i
        },
        _get: function(n, i) {
            return n.settings[i] !== t ? n.settings[i] : this._defaults[i]
        },
        _setDateFromField: function(n, t) {
            var u, r, i, f, e;
            if (n.input.val() != n.lastVal) {
                u = this._get(n, "dateFormat");
                r = n.lastVal = n.input ? n.input.val() : null;
                i = f = this._getDefaultDate(n);
                e = this._getFormatConfig(n);
                try {
                    i = this.parseDate(u, r, e) || f
                } catch (o) {
                    this.log(o);
                    r = t ? "" : r
                }
                n.selectedDay = i.getDate();
                n.drawMonth = n.selectedMonth = i.getMonth();
                n.drawYear = n.selectedYear = i.getFullYear();
                n.currentDay = r ? i.getDate() : 0;
                n.currentMonth = r ? i.getMonth() : 0;
                n.currentYear = r ? i.getFullYear() : 0;
                this._adjustInstDate(n)
            }
        },
        _getDefaultDate: function(n) {
            return this.CDate = this._get(n, "calendar"), this._restrictMinMax(n, this._determineDate(n, this._get(n, "defaultDate"), new this.CDate))
        },
        _determineDate: function(t, i, r) {
            var f = this.CDate,
                e = function(n) {
                    var t = new f;
                    return t.setDate(t.getDate() + n), t
                },
                o = function(i) {
                    try {
                        return n.datepicker.parseDate(n.datepicker._get(t, "dateFormat"), i, n.datepicker._getFormatConfig(t))
                    } catch (c) {}
                    for (var s = (i.toLowerCase().match(/^c/) ? n.datepicker._getDate(t) : null) || new f, e = s.getFullYear(), o = s.getMonth(), r = s.getDate(), h = /([+-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, u = h.exec(i); u;) {
                        switch (u[2] || "d") {
                            case "d":
                            case "D":
                                r += parseInt(u[1], 10);
                                break;
                            case "w":
                            case "W":
                                r += parseInt(u[1], 10) * 7;
                                break;
                            case "m":
                            case "M":
                                o += parseInt(u[1], 10);
                                r = Math.min(r, n.datepicker._getDaysInMonth(e, o));
                                break;
                            case "y":
                            case "Y":
                                e += parseInt(u[1], 10);
                                r = Math.min(r, n.datepicker._getDaysInMonth(e, o))
                        }
                        u = h.exec(i)
                    }
                    return new f(e, o, r)
                },
                u = i == null || i === "" ? r : typeof i == "string" ? o(i) : typeof i == "number" ? isNaN(i) ? r : e(i) : new f(i.getTime());
            return u = u && u.toString() == "Invalid Date" ? r : u, u && (u.setHours(0), u.setMinutes(0), u.setSeconds(0), u.setMilliseconds(0)), this._daylightSavingAdjust(u)
        },
        _daylightSavingAdjust: function(n) {
            return n ? (n.setHours(n.getHours() > 12 ? n.getHours() + 2 : 0), n) : null
        },
        _setDate: function(n, t, i) {
            var u = !t,
                f = n.selectedMonth,
                e = n.selectedYear,
                r;
            this.CDate = this._get(n, "calendar");
            r = this._restrictMinMax(n, this._determineDate(n, t, new this.CDate));
            n.selectedDay = n.currentDay = r.getDate();
            n.drawMonth = n.selectedMonth = n.currentMonth = r.getMonth();
            n.drawYear = n.selectedYear = n.currentYear = r.getFullYear();
            f == n.selectedMonth && e == n.selectedYear || i || this._notifyChange(n);
            this._adjustInstDate(n);
            n.input && n.input.val(u ? "" : this._formatDate(n))
        },
        _getDate: function(n) {
            this.CDate = this._get(n, "calendar");
            return !n.currentYear || n.input && n.input.val() == "" ? null : this._daylightSavingAdjust(new this.CDate(n.currentYear, n.currentMonth, n.currentDay))
        },
        _attachHandlers: function(t) {
            var u = this._get(t, "stepMonths"),
                i = "#" + t.id.replace(/\\\\/g, "\\");
            t.dpDiv.find("[data-handler]").map(function() {
                var t = {
                    prev: function() {
                        window["DP_jQuery_" + r].datepicker._adjustDate(i, -u, "M")
                    },
                    next: function() {
                        window["DP_jQuery_" + r].datepicker._adjustDate(i, +u, "M")
                    },
                    hide: function() {
                        window["DP_jQuery_" + r].datepicker._hideDatepicker()
                    },
                    today: function() {
                        window["DP_jQuery_" + r].datepicker._gotoToday(i)
                    },
                    selectDay: function() {
                        return window["DP_jQuery_" + r].datepicker._selectDay(i, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1;



                    },
                    selectMonth: function() {
                        return window["DP_jQuery_" + r].datepicker._selectMonthYear(i, this, "M"), !1
                    },
                    selectYear: function() {
                        return window["DP_jQuery_" + r].datepicker._selectMonthYear(i, this, "Y"), !1
                    }
                };
                n(this).bind(this.getAttribute("data-event"), t[this.getAttribute("data-handler")])
            })
        },
        _generateHTML: function(t) {
            var h = new this.CDate,
                d, v, ut, y, p, ot, w, st, ht, ct, r, at, vt, s;
            h = this._daylightSavingAdjust(new this.CDate(h.getFullYear(), h.getMonth(), h.getDate()));
            var e = this._get(t, "isRTL"),
                fi = this._get(t, "showButtonPanel"),
                pt = this._get(t, "hideIfNoPrevNext"),
                tt = this._get(t, "navigationAsDateFormat"),
                o = this._getNumberOfMonths(t),
                ei = this._get(t, "showCurrentAtPos"),
                wt = this._get(t, "stepMonths"),
                it = o[0] != 1 || o[1] != 1,
                rt = this._daylightSavingAdjust(t.currentDay ? new this.CDate(t.currentYear, t.currentMonth, t.currentDay) : new Date(9999, 9, 9)),
                a = this._getMinMaxDate(t, "min"),
                c = this._getMinMaxDate(t, "max"),
                i = t.drawMonth - ei,
                u = t.drawYear;
            if (i < 0 && (i += 12, u--), c)
                for (d = this._daylightSavingAdjust(new this.CDate(c.getFullYear(), c.getMonth() - o[0] * o[1] + 1, c.getDate())), d = a && d < a ? a : d; this._daylightSavingAdjust(new this.CDate(u, i, 1)) > d;) i--, i < 0 && (i = 11, u--);
            t.drawMonth = i;
            t.drawYear = u;
            v = this._get(t, "prevText");
            v = tt ? this.formatDate(v, this._daylightSavingAdjust(new this.CDate(u, i - wt, 1)), this._getFormatConfig(t)) : v;
            ut = this._canAdjustMonth(t, -1, u, i) ? '<a class="ui-datepicker-prev btn btn-link" data-handler="prev" data-event="click" title="' + v + '">' + (e ? '<i class="icon-circle-arrow-right"><\/i>' : '<i class="icon-circle-arrow-left"><\/i>') + "<\/a>" : pt ? "" : '<a class="ui-datepicker-prev btn btn-link ui-state-disabled" title="' + v + '">' + (e ? '<i class="icon-circle-arrow-right"><\/i>' : '<i class="icon-circle-arrow-left"><\/i>') + "<\/a>";
            y = this._get(t, "nextText");
            y = tt ? this.formatDate(y, this._daylightSavingAdjust(new this.CDate(u, i + wt, 1)), this._getFormatConfig(t)) : y;
            var bt = this._canAdjustMonth(t, 1, u, i) ? '<a class="ui-datepicker-next btn btn-link" data-handler="next" data-event="click" title="' + y + '">' + (e ? '<i class="icon-circle-arrow-left"><\/i>' : '<i class="icon-circle-arrow-right"><\/i>') + "<\/a>" : pt ? "" : '<a class="ui-datepicker-next btn btn-link ui-state-disabled" title="' + y + '">' + (e ? '<i class="icon-circle-arrow-left"><\/i>' : '<i class="icon-circle-arrow-right"><\/i>') + "<\/a>",
                g = this._get(t, "currentText"),
                kt = this._get(t, "gotoCurrent") && t.currentDay ? rt : h;
            g = tt ? this.formatDate(g, kt, this._getFormatConfig(t)) : g;
            var dt = t.inline ? "" : '<button type="button" class="ui-datepicker-close btn" data-handler="hide" data-event="click">' + this._get(t, "closeText") + "<\/button>",
                oi = fi ? '<div class="ui-datepicker-buttonpane ui-helper-clearfix">' + (e ? dt : "") + (this._isInRange(t, kt) ? '<button type="button" class="ui-datepicker-current btn" data-handler="today" data-event="click">' + g + "<\/button>" : "") + (e ? "" : dt) + "<\/div>" : "",
                l = parseInt(this._get(t, "firstDay"), 10);
            l = isNaN(l) ? 0 : l;
            var gt = this._get(t, "showWeek"),
                si = this._get(t, "dayNames"),
                vi = this._get(t, "dayNamesShort"),
                hi = this._get(t, "dayNamesMin"),
                ci = this._get(t, "monthNames"),
                li = this._get(t, "monthNamesShort"),
                ni = this._get(t, "beforeShowDay"),
                ft = this._get(t, "showOtherMonths"),
                ai = this._get(t, "selectOtherMonths"),
                yi = this._get(t, "calculateWeek") || this.iso8601Week,
                ti = this._getDefaultDate(t),
                et = "";
            for (p = 0; p < o[0]; p++) {
                for (ot = "", this.maxRows = 4, w = 0; w < o[1]; w++) {
                    var ii = this._daylightSavingAdjust(new this.CDate(u, i, t.selectedDay)),
                        b = " ui-corner-all",
                        f = "";
                    if (it) {
                        if (f += '<div class="ui-datepicker-group', o[1] > 1) switch (w) {
                            case 0:
                                f += " ui-datepicker-group-first";
                                b = " ui-corner-" + (e ? "right" : "left");
                                break;
                            case o[1] - 1:
                                f += " ui-datepicker-group-last";
                                b = " ui-corner-" + (e ? "left" : "right");
                                break;
                            default:
                                f += " ui-datepicker-group-middle";
                                b = ""
                        }
                        f += '">'
                    }
                    for (f += '<div class="ui-datepicker-header ui-widget-header ui-helper-clearfix' + b + '">' + (/all|left/.test(b) && p == 0 ? e ? bt : ut : "") + (/all|right/.test(b) && p == 0 ? e ? ut : bt : "") + this._generateMonthYearHeader(t, i, u, a, c, p > 0 || w > 0, ci, li) + '<\/div><table class="ui-datepicker-calendar"><thead><tr>', st = gt ? '<th class="ui-datepicker-week-col">' + this._get(t, "weekHeader") + "<\/th>" : "", s = 0; s < 7; s++) ht = (s + l) % 7, st += "<th" + ((s + l + 6) % 7 >= 5 ? ' class="ui-datepicker-week-end"' : "") + '><span title="' + si[ht] + '">' + hi[ht] + "<\/span><\/th>";
                    f += st + "<\/tr><\/thead><tbody>";
                    ct = this._getDaysInMonth(u, i);
                    u == t.selectedYear && i == t.selectedMonth && (t.selectedDay = Math.min(t.selectedDay, ct));
                    var ri = (this._getFirstDayOfMonth(u, i) - l + 7) % 7,
                        lt = Math.ceil((ri + ct) / 7),
                        ui = it ? this.maxRows > lt ? this.maxRows : lt : lt;
                    for (this.maxRows = ui, r = this._daylightSavingAdjust(new this.CDate(u, i, 1 - ri)), at = 0; at < ui; at++) {
                        for (f += "<tr>", vt = gt ? '<td class="ui-datepicker-week-col">' + this._get(t, "calculateWeek")(r) + "<\/td>" : "", s = 0; s < 7; s++) {
                            var nt = ni ? ni.apply(t.input ? t.input[0] : null, [r]) : [!0, ""],
                                k = r.getMonth() != i,
                                yt = k && !ai || !nt[0] || a && this._compareDate(r, "<", a) || c && this._compareDate(r, ">", c);
                            vt += '<td class="' + ((s + l + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (k ? " ui-datepicker-other-month" : "") + (r.getTime() == ii.getTime() && i == t.selectedMonth && t._keyEvent || ti.getTime() == r.getTime() && ti.getTime() == ii.getTime() ? " " + this._dayOverClass : "") + (yt ? " " + this._unselectableClass + " ui-state-disabled" : "") + (k && !ft ? "" : " " + nt[1] + (r.getTime() == rt.getTime() ? " " + this._currentClass : "") + (r.getTime() == h.getTime() ? " ui-datepicker-today" : "")) + '"' + ((!k || ft) && nt[2] ? ' title="' + nt[2] + '"' : "") + (yt ? "" : ' data-handler="selectDay" data-event="click" data-month="' + r.getMonth() + '" data-year="' + r.getFullYear() + '"') + ">" + (k && !ft ? "&#xa0;" : yt ? '<span class="ui-state-default">' + r.getDate() + "<\/span>" : '<a class="ui-state-default' + (r.getTime() == h.getTime() ? " ui-state-highlight" : "") + (r.getTime() == rt.getTime() ? " ui-state-active" : "") + (k ? " ui-priority-secondary" : "") + '" href="#">' + r.getDate() + "<\/a>") + "<\/td>";
                            r.setDate(r.getDate() + 1);
                            r = this._daylightSavingAdjust(r)
                        }
                        f += vt + "<\/tr>"
                    }
                    i++;
                    i > 11 && (i = 0, u++);
                    f += "<\/tbody><\/table>" + (it ? "<\/div>" + (o[0] > 0 && w == o[1] - 1 ? '<div class="ui-datepicker-row-break"><\/div>' : "") : "");
                    ot += f
                }
                et += ot
            }
            return et += oi + (n.ui.ie6 && !t.inline ? '<iframe src="javascript:false;" class="ui-datepicker-cover" frameborder="0"><\/iframe>' : ""), t._keyEvent = !1, et
        },
        _generateMonthYearHeader: function(n, t, i, r, u, f, e, o) {
            var v = this._get(n, "changeMonth"),
                y = this._get(n, "changeYear"),
                p = this._get(n, "showMonthAfterYear"),
                c = '<div class="ui-datepicker-title">',
                l = "",
                w, b, h;
            if (f || !v) l += '<span class="ui-datepicker-month">' + e[t] + "<\/span>";
            else {
                for (w = r && r.getFullYear() == i, b = u && u.getFullYear() == i, l += '<select class="ui-datepicker-month" data-handler="selectMonth" data-event="change">', h = 0; h < 12; h++)(!w || h >= r.getMonth()) && (!b || h <= u.getMonth()) && (l += '<option value="' + h + '"' + (h == t ? ' selected="selected"' : "") + ">" + o[h] + "<\/option>");
                l += "<\/select>"
            }
            if (p || (c += l + (f || !(v && y) ? "&#xa0;" : "")), !n.yearshtml)
                if (n.yearshtml = "", f || !y) c += '<span class="ui-datepicker-year">' + i + "<\/span>";
                else {
                    var k = this._get(n, "yearRange").split(":"),
                        d = (new this.CDate).getFullYear(),
                        g = function(n) {
                            var t = n.match(/c[+-].*/) ? i + parseInt(n.substring(1), 10) : n.match(/[+-].*/) ? d + parseInt(n, 10) : parseInt(n, 10);
                            return isNaN(t) ? d : t
                        },
                        s = g(k[0]),
                        a = Math.max(s, g(k[1] || ""));
                    for (s = r ? Math.max(s, r.getFullYear()) : s, a = u ? Math.min(a, u.getFullYear()) : a, n.yearshtml += '<select class="ui-datepicker-year" data-handler="selectYear" data-event="change">'; s <= a; s++) n.yearshtml += '<option value="' + s + '"' + (s == i ? ' selected="selected"' : "") + ">" + s + "<\/option>";
                    n.yearshtml += "<\/select>";
                    c += n.yearshtml;
                    n.yearshtml = null
                } return c += this._get(n, "yearSuffix"), p && (c += (f || !(v && y) ? "&#xa0;" : "") + l), c + "<\/div>"
        },
        _adjustInstDate: function(n, t, i) {
            var u = n.drawYear + (i == "Y" ? t : 0),
                f = n.drawMonth + (i == "M" ? t : 0),
                e = Math.min(n.selectedDay, this._getDaysInMonth(u, f)) + (i == "D" ? t : 0),
                r = this._restrictMinMax(n, this._daylightSavingAdjust(new this.CDate(u, f, e)));
            n.selectedDay = r.getDate();
            n.drawMonth = n.selectedMonth = r.getMonth();
            n.drawYear = n.selectedYear = r.getFullYear();
            (i == "M" || i == "Y") && this._notifyChange(n)
        },
        _restrictMinMax: function(n, t) {
            var i = this._getMinMaxDate(n, "min"),
                r = this._getMinMaxDate(n, "max"),
                u = i && this._compareDate(t, "<", i) ? i : t;
            return r && this._compareDate(u, ">", r) ? r : u
        },
        _notifyChange: function(n) {
            var t = this._get(n, "onChangeMonthYear");
            t && t.apply(n.input ? n.input[0] : null, [n.selectedYear, n.selectedMonth + 1, n])
        },
        _getNumberOfMonths: function(n) {
            var t = this._get(n, "numberOfMonths");
            return t == null ? [1, 1] : typeof t == "number" ? [1, t] : t
        },
        _getMinMaxDate: function(n, t) {
            return this._determineDate(n, this._get(n, t + "Date"), null)
        },
        _getDaysInMonth: function(n, t) {
            return 32 - this._daylightSavingAdjust(new this.CDate(n, t, 32)).getDate()
        },
        _getFirstDayOfMonth: function(n, t) {
            return new this.CDate(n, t, 1).getDay()
        },
        _canAdjustMonth: function(n, t, i, r) {
            var f = this._getNumberOfMonths(n),
                u = this._daylightSavingAdjust(new this.CDate(i, r + (t < 0 ? t : f[0] * f[1]), 1));
            return t < 0 && u.setDate(this._getDaysInMonth(u.getFullYear(), u.getMonth())), this._isInRange(n, u)
        },
        _isInRange: function(n, t) {
            var i = this._getMinMaxDate(n, "min"),
                r = this._getMinMaxDate(n, "max");
            return (!i || t.getTime() >= i.getTime()) && (!r || t.getTime() <= r.getTime())
        },
        _getFormatConfig: function(n) {
            var t = this._get(n, "shortYearCutoff");
            return this.CDate = this._get(n, "calendar"), t = typeof t != "string" ? t : (new this.CDate).getFullYear() % 100 + parseInt(t, 10), {
                shortYearCutoff: t,
                dayNamesShort: this._get(n, "dayNamesShort"),
                dayNames: this._get(n, "dayNames"),
                monthNamesShort: this._get(n, "monthNamesShort"),
                monthNames: this._get(n, "monthNames")
            }
        },
        _formatDate: function(n, t, i, r) {
            t || (n.currentDay = n.selectedDay, n.currentMonth = n.selectedMonth, n.currentYear = n.selectedYear);
            var u = t ? typeof t == "object" ? t : this._daylightSavingAdjust(new this.CDate(r, i, t)) : this._daylightSavingAdjust(new this.CDate(n.currentYear, n.currentMonth, n.currentDay));
            return this.formatDate(this._get(n, "dateFormat"), u, this._getFormatConfig(n))
        },
        _compareDate: function(n, t, i) {
            return n && i ? (n.getGregorianDate && (n = n.getGregorianDate()), i.getGregorianDate && (i = i.getGregorianDate()), t == "<") ? n < i : n > i : null
        }
    });
    n.fn.datepicker = function(t) {
        if (!this.length) return this;
        n.datepicker.initialized || (n(document).mousedown(n.datepicker._checkExternalClick).find(document.body).append(n.datepicker.dpDiv), n.datepicker.initialized = !0);
        var i = Array.prototype.slice.call(arguments, 1);
        return typeof t == "string" && (t == "isDisabled" || t == "getDate" || t == "widget") ? n.datepicker["_" + t + "Datepicker"].apply(n.datepicker, [this[0]].concat(i)) : t == "option" && arguments.length == 2 && typeof arguments[1] == "string" ? n.datepicker["_" + t + "Datepicker"].apply(n.datepicker, [this[0]].concat(i)) : this.each(function() {
            typeof t == "string" ? n.datepicker["_" + t + "Datepicker"].apply(n.datepicker, [this].concat(i)) : n.datepicker._attachDatepicker(this, t)
        })
    };
    n.datepicker = new e;
    n.datepicker.initialized = !1;
    n.datepicker.uuid = (new Date).getTime();
    n.datepicker.version = "1.9.1";
    window["DP_jQuery_" + r] = n
}(jQuery);
var GREGORIAN_EPOCH = 1721425.5,
    ISLAMIC_EPOCH = 1948439.5,
    PERSIAN_EPOCH = 1948320.5;
jQuery(function(n) {
    n.datepicker.regional.fa = {
        calendar: JalaliDate,
        closeText: "بستن",
        prevText: "قبل",
        nextText: "بعد",
        currentText: "امروز",
        monthNames: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
        monthNamesShort: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
        dayNames: ["یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"],
        dayNamesShort: ["یک", "دو", "سه", "چهار", "پنج", "جمعه", "شنبه"],
        dayNamesMin: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
        weekHeader: "ه",
        dateFormat: "yy-mm-dd",
        firstDay: 6,
        isRTL: !0,
        showMonthAfterYear: !1,
        yearSuffix: "",
        calculateWeek: function(n) {
            var t = new JalaliDate(n.getFullYear(), n.getMonth(), n.getDate() + (n.getDay() || 7) - 3);
            return Math.floor(Math.round((t.getTime() - new JalaliDate(t.getFullYear(), 0, 1).getTime()) / 864e5) / 7) + 1
        }
    };
    n.datepicker.setDefaults(n.datepicker.regional.fa)
});
var GREGORIAN_EPOCH = 1721425.5,
    PERSIAN_EPOCH = 1948320.5,
    ISLAMIC_EPOCH = 1948439.5